export const duplicateVendor =
  /* GraphQL */
  `
    mutation MyMutation($vendorId: String!, $currentHotelId: String!, $requestHotelId: String!) {
      duplicateVendor(
        input: { id: $vendorId, currentHotelId: $currentHotelId, requestHotelId: $requestHotelId }
      ) {
        message
        status
      }
    }
  `;

export const createVendor =
  /* GraphQL */
  `
    mutation MyMutation(
      $name: String!
      $type: VendorType!
      $hotelId: String!
      $attributes: [String]!
    ) {
      createVendor(
        input: { type: $type, name: $name, hotelId: $hotelId, enabledAttributes: $attributes }
      ) {
        status
        message
      }
    }
  `;

export const deleteVendor =
  /* GraphQL */
  `
    mutation MyMutation($hotelId: String!, $id: String!) {
      deleteVendor(input: { hotelId: $hotelId, id: $id }) {
        message
        status
      }
    }
  `;

export const updateVendor =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $name: String!
      $type: VendorType!
      $hotelId: String!
      $attributes: [String]!
    ) {
      updateVendor(
        input: {
          type: $type
          name: $name
          hotelId: $hotelId
          enabledAttributes: $attributes
          id: $id
        }
      ) {
        message
        status
      }
    }
  `;

export const createGroup =
  /* GraphQL */
  `
    mutation MyMutation(
      $code: String!
      $description: String!
      $name: String!
      $customSenderEmail: String!
      $firebaseToken: String
      $lang: String
    ) {
      createGroup(
        input: {
          code: $code
          description: $description
          name: $name
          customSenderEmail: $customSenderEmail
          firebaseToken: $firebaseToken
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const createBrand =
  /* GraphQL */
  `
    mutation MyMutation(
      $code: String!
      $groupId: String!
      $name: String!
      $description: String!
      $images: [ImagesInput]
      $mediaContent: [CustomAttributeInput]
      $lang: String
    ) {
      createBrand(
        input: {
          code: $code
          groupId: $groupId
          name: $name
          description: $description
          images: $images
          mediaContent: $mediaContent
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const updateGroup =
  /* GraphQL */
  `
    mutation MyMutation(
      $code: String!
      $id: String!
      $description: String!
      $name: String!
      $customSenderEmail: String!
      $firebaseToken: String
      $lang: String
    ) {
      updateGroup(
        input: {
          code: $code
          id: $id
          description: $description
          name: $name
          customSenderEmail: $customSenderEmail
          firebaseToken: $firebaseToken
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const updateGroupWithLanguage =
  /* GraphQL */
  `
    mutation MyMutation(
      $code: String!
      $groupId: String!
      $description: String!
      $name: String!
      $customSenderEmail: String!
      $lang: String!
    ) {
      updateGroupLanguage(
        input: {
          code: $code
          groupId: $groupId
          description: $description
          name: $name
          customSenderEmail: $customSenderEmail
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const updateBrand =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $code: String!
      $groupId: String!
      $description: String!
      $name: String!
      $images: [ImagesInput]
      $mediaContent: [CustomAttributeInput]
      $lang: String
    ) {
      updateBrand(
        input: {
          id: $id
          code: $code
          groupId: $groupId
          description: $description
          name: $name
          images: $images
          mediaContent: $mediaContent
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const updateBrandWithLanguage =
  /* GraphQL */
  `
    mutation MyMutation(
      $brandId: String!
      $code: String!
      $groupId: String!
      $description: String!
      $name: String!
      $images: [ImagesInput]
      $lang: String!
    ) {
      updateBrandLanguage(
        input: {
          brandId: $brandId
          code: $code
          groupId: $groupId
          description: $description
          name: $name
          images: $images
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const deleteGroup =
  /* GraphQL */
  `
    mutation MyMutation($id: String!) {
      deleteGroup(input: { id: $id }) {
        status
      }
    }
  `;

export const deleteGroupByLanguage =
  /* GraphQL */
  `
    mutation MyMutation($groupId: String!, $lang: String!) {
      deleteGroupLanguage(input: { groupId: $groupId, lang: $lang }) {
        status
      }
    }
  `;

export const deleteBrand =
  /* GraphQL */
  `
    mutation MyMutation($id: String!, $groupId: String!) {
      deleteBrand(input: { id: $id, groupId: $groupId }) {
        status
      }
    }
  `;

export const deleteBrandByLang =
  /* GraphQL */
  `
    mutation MyMutation($brandId: String!, $lang: String!) {
      deleteBrandLanguage(input: { brandId: $brandId, lang: $lang }) {
        status
      }
    }
  `;

export const createHotel =
  /* GraphQL */
  `
    mutation MyMutation(
      $brandId: String!
      $checkInTime: String!
      $checkOutTime: String!
      $code: String!
      $currency: String!
      $description: String!
      $groupId: String!
      $images: [ImagesInput]
      $information: [HotelInformationInput]
      $location: LocationInput!
      $name: String!
      $features: [String]
      $covid19Regulations: DocumentInput
      $termsAndConditions: DocumentInput
      $cancellationPolicy: DocumentInput
      $dataProtection: DocumentInput
      $privacyLaws: DocumentInput
      $phoneNumber: String!
      $starRating: String
      $interests: [String]
      $travelType: [String]
      $wcMessage: WCMessageInput
      $lang: String
      $detailsCustomAttributes: [CustomAttributeInput]
      $informationCustomAttributes: [CustomAttributeInput]
      $mediaContent: [CustomAttributeInput]
    ) {
      createHotel(
        input: {
          brandId: $brandId
          checkInTime: $checkInTime
          checkOutTime: $checkOutTime
          code: $code
          currency: $currency
          description: $description
          groupId: $groupId
          images: $images
          information: $information
          location: $location
          name: $name
          features: $features
          covid19Regulations: $covid19Regulations
          termsAndConditions: $termsAndConditions
          cancellationPolicy: $cancellationPolicy
          dataProtection: $dataProtection
          privacyLaws: $privacyLaws
          phoneNumber: $phoneNumber
          starRating: $starRating
          interests: $interests
          travelType: $travelType
          wcMessage: $wcMessage
          lang: $lang
          informationCustomAttributes: $informationCustomAttributes
          detailsCustomAttributes: $detailsCustomAttributes
          mediaContent: $mediaContent
        }
      ) {
        id
      }
    }
  `;

export const updateHotel =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $brandId: String!
      $checkInTime: String!
      $checkOutTime: String!
      $code: String!
      $currency: String!
      $description: String!
      $groupId: String!
      $images: [ImagesInput]
      $features: [String]
      $information: [HotelInformationInput]
      $location: LocationInput!
      $name: String!
      $phoneNumber: String!
      $starRating: String
      $interests: [String]
      $travelType: [String]
      $covid19Regulations: DocumentInput
      $termsAndConditions: DocumentInput
      $cancellationPolicy: DocumentInput
      $dataProtection: DocumentInput
      $privacyLaws: DocumentInput
      $wcMessage: WCMessageInput
      $lang: String
      $detailsCustomAttributes: [CustomAttributeInput]
      $informationCustomAttributes: [CustomAttributeInput]
      $mediaContent: [CustomAttributeInput]
    ) {
      updateHotel(
        input: {
          id: $id
          brandId: $brandId
          checkInTime: $checkInTime
          checkOutTime: $checkOutTime
          code: $code
          currency: $currency
          description: $description
          groupId: $groupId
          images: $images
          features: $features
          information: $information
          location: $location
          name: $name
          phoneNumber: $phoneNumber
          starRating: $starRating
          interests: $interests
          travelType: $travelType
          covid19Regulations: $covid19Regulations
          termsAndConditions: $termsAndConditions
          cancellationPolicy: $cancellationPolicy
          dataProtection: $dataProtection
          privacyLaws: $privacyLaws
          wcMessage: $wcMessage
          lang: $lang
          informationCustomAttributes: $informationCustomAttributes
          detailsCustomAttributes: $detailsCustomAttributes
          mediaContent: $mediaContent
        }
      ) {
        id
      }
    }
  `;

export const updateHotelByLanguage =
  /* GraphQL */
  `
    mutation MyMutation(
      $hotelId: String!
      $brandId: String!
      $checkInTime: String!
      $checkOutTime: String!
      $code: String!
      $currency: String!
      $description: String!
      $groupId: String!
      $images: [ImagesInput]
      $features: [String]
      $information: [HotelInformationInput]
      $location: LocationInput!
      $name: String!
      $phoneNumber: String!
      $starRating: String
      $interests: [String]
      $travelType: [String]
      $covid19Regulations: DocumentInput
      $termsAndConditions: DocumentInput
      $cancellationPolicy: DocumentInput
      $dataProtection: DocumentInput
      $privacyLaws: DocumentInput
      $lang: String!
    ) {
      updateHotelLanguage(
        input: {
          hotelId: $hotelId
          brandId: $brandId
          checkInTime: $checkInTime
          checkOutTime: $checkOutTime
          code: $code
          currency: $currency
          description: $description
          groupId: $groupId
          images: $images
          features: $features
          information: $information
          location: $location
          name: $name
          phoneNumber: $phoneNumber
          starRating: $starRating
          interests: $interests
          travelType: $travelType
          covid19Regulations: $covid19Regulations
          termsAndConditions: $termsAndConditions
          cancellationPolicy: $cancellationPolicy
          dataProtection: $dataProtection
          privacyLaws: $privacyLaws
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const deleteHotel =
  /* GraphQL */
  `
    mutation MyMutation($id: String!) {
      deleteHotel(input: { id: $id }) {
        status
      }
    }
  `;

export const deleteHotelLang =
  /* GraphQL */
  `
    mutation MyMutation($hotelId: String!, $lang: String!) {
      deleteHotelLanguage(input: { hotelId: $hotelId, lang: $lang }) {
        status
      }
    }
  `;

export const updateHotelUIBuilderState =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $brandId: String!
      $groupId: String!
      $isUIBuilderEnabled: Boolean!
    ) {
      updateHotelUIBuilderState(
        input: {
          id: $id
          brandId: $brandId
          groupId: $groupId
          isUIBuilderEnabled: $isUIBuilderEnabled
        }
      ) {
        id
      }
    }
  `;

export const updateHotelDeviceModuleState =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $brandId: String!
      $groupId: String!
      $isDevicesEnabled: Boolean!
      $devicesEndpoint: String
    ) {
      updateHotelDevicesState(
        input: {
          id: $id
          brandId: $brandId
          groupId: $groupId
          isDevicesEnabled: $isDevicesEnabled
          devicesEndpoint: $devicesEndpoint
        }
      ) {
        id
      }
    }
  `;
export const getPreSignedS3Url =
  /* GraphQL */
  `
    mutation getPreSignUrlCMS($input: GetPreSignUrlInput!) {
      getPreSignUrlCMS(input: $input) {
        headers
        key
        method
        url
      }
    }
  `;

// start og Accomodation related mutations
// start of Category mutations

export const createCategory =
  /* GraphQL */
  `
    mutation MyMutation($code: String!, $name: String!, $hotelId: String!, $lang: String) {
      createCategory(input: { code: $code, name: $name, hotelId: $hotelId, lang: $lang }) {
        id
      }
    }
  `;

export const updateCategory =
  /* GraphQL */
  `
    mutation MyMutation(
      $code: String!
      $name: String!
      $hotelId: String!
      $id: String!
      $lang: String
    ) {
      updateCategory(input: { code: $code, name: $name, hotelId: $hotelId, id: $id, lang: $lang }) {
        id
      }
    }
  `;

// start of Floor mutations

export const createFloor =
  /* GraphQL */
  `
    mutation MyMutation(
      $number: Int!
      $name: String!
      $hotelId: String!
      $roomRangeList: [RoomRangeInput]!
      $lang: String
    ) {
      createFloor(
        input: {
          number: $number
          name: $name
          hotelId: $hotelId
          roomRangeList: $roomRangeList
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const updateFloor =
  /* GraphQL */
  `
    mutation MyMutation(
      $number: Int!
      $name: String!
      $hotelId: String!
      $roomRangeList: [RoomRangeInput]!
      $id: String!
      $lang: String
    ) {
      updateFloor(
        input: {
          id: $id
          number: $number
          name: $name
          hotelId: $hotelId
          roomRangeList: $roomRangeList
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const createRoomType =
  /* GraphQL */
  `
    mutation MyMutation(
      $code: String!
      $name: String!
      $categoryId: String!
      $description: String
      $displayDescription: String!
      $displayName: String!
      $features: [String]
      $images: [ImagesInput]
      $maxAdults: Int!
      $maxBeddingPerRoomType: Int!
      $maxChildren: Int!
      $maxInfants: Int!
      $maxOccupants: Int!
      $ratePerNight: Float!
      $hotelId: String!
      $lang: String
      $isActive: Boolean
      $mediaContent: [CustomAttributeInput]
    ) {
      createRoomType(
        input: {
          code: $code
          name: $name
          categoryId: $categoryId
          description: $description
          displayDescription: $displayDescription
          displayName: $displayName
          features: $features
          images: $images
          mediaContent: $mediaContent
          maxAdults: $maxAdults
          maxBeddingPerRoomType: $maxBeddingPerRoomType
          maxChildren: $maxChildren
          maxInfants: $maxInfants
          maxOccupants: $maxOccupants
          ratePerNight: $ratePerNight
          hotelId: $hotelId
          lang: $lang
          isActive: $isActive
        }
      ) {
        id
      }
    }
  `;

export const updateRoomType =
  /* GraphQL */
  `
    mutation MyMutation(
      $code: String!
      $name: String!
      $categoryId: String!
      $description: String
      $displayDescription: String!
      $displayName: String!
      $features: [String]
      $images: [ImagesInput]
      $maxAdults: Int!
      $maxBeddingPerRoomType: Int!
      $maxChildren: Int!
      $maxInfants: Int!
      $maxOccupants: Int!
      $ratePerNight: Float!
      $hotelId: String!
      $id: String!
      $lang: String
      $isActive: Boolean
      $mediaContent: [CustomAttributeInput]
    ) {
      updateRoomType(
        input: {
          code: $code
          name: $name
          categoryId: $categoryId
          description: $description
          displayDescription: $displayDescription
          displayName: $displayName
          features: $features
          images: $images
          maxAdults: $maxAdults
          maxBeddingPerRoomType: $maxBeddingPerRoomType
          maxChildren: $maxChildren
          maxInfants: $maxInfants
          maxOccupants: $maxOccupants
          ratePerNight: $ratePerNight
          hotelId: $hotelId
          id: $id
          lang: $lang
          isActive: $isActive
          mediaContent: $mediaContent
        }
      ) {
        id
      }
    }
  `;
export const createRoom =
  /* GraphQL */
  `
    mutation MyMutation(
      $number: String!
      $roomTypeId: String!
      $description: String!
      $area: Int!
      $areaSizeUnit: String!
      $roomView: String!
      $isSmokingAllowed: Boolean!
      $maxOccupancy: Int!
      $houseKeepingDaySection: String!
      $houseKeepingEveningSection: String!
      $isActive: Boolean!
      $isAdultRequired: Boolean!
      $hotelId: String!
      $lang: String
    ) {
      createRoom(
        input: {
          number: $number
          roomTypeId: $roomTypeId
          description: $description
          area: $area
          areaSizeUnit: $areaSizeUnit
          roomView: $roomView
          isSmokingAllowed: $isSmokingAllowed
          maxOccupancy: $maxOccupancy
          houseKeepingDaySection: $houseKeepingDaySection
          houseKeepingEveningSection: $houseKeepingEveningSection
          isActive: $isActive
          isAdultRequired: $isAdultRequired
          hotelId: $hotelId
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const updateRoom =
  /* GraphQL */
  `
    mutation MyMutation(
      $number: String!
      $roomTypeId: String!
      $description: String!
      $area: Int!
      $areaSizeUnit: String!
      $roomView: String!
      $isSmokingAllowed: Boolean!
      $maxOccupancy: Int!
      $houseKeepingDaySection: String!
      $houseKeepingEveningSection: String!
      $isActive: Boolean!
      $isAdultRequired: Boolean!
      $hotelId: String!
      $id: String!
      $lang: String
    ) {
      updateRoom(
        input: {
          number: $number
          roomTypeId: $roomTypeId
          description: $description
          area: $area
          areaSizeUnit: $areaSizeUnit
          roomView: $roomView
          isSmokingAllowed: $isSmokingAllowed
          maxOccupancy: $maxOccupancy
          houseKeepingDaySection: $houseKeepingDaySection
          houseKeepingEveningSection: $houseKeepingEveningSection
          isActive: $isActive
          isAdultRequired: $isAdultRequired
          hotelId: $hotelId
          id: $id
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const createPersonalisation = `
  mutation MyMutation(
    $code: String!, 
    $cost: Float!, 
    $description: String!, 
    $hotelId: String!, 
    $isActive: Boolean!, 
    $name: String!, 
    $unit: String!, 
    $maxQuantity:PersonalisationMaxQuantityInput,
    $personalisationCategory:PersonalisationCategoryInput,
    $lang: String

    ) {
    createPersonalisation(
      input: {
        code: $code, 
        cost: $cost, 
        description: $description, 
        hotelId: $hotelId, 
        isActive: $isActive, 
        name: $name, 
        unit: $unit
        maxQuantity:$maxQuantity,
        personalisationCategory:$personalisationCategory,
        lang:$lang
      }
    ){
      id
    }
  }
`;

export const updatePersonalisation = `
  mutation MyMutation(
    $code: String!, 
    $cost: Float!, 
    $description: String!, 
    $hotelId: String!, 
    $isActive: Boolean!, 
    $name: String!, 
    $unit: String!,
    $maxQuantity:PersonalisationMaxQuantityInput,
    $personalisationCategory:PersonalisationCategoryInput,
    $id: String! 
    $lang:String
    ) {
      updatePersonalisation(
      input: {
        code: $code, 
        cost: $cost, 
        description: $description, 
        hotelId: $hotelId, 
        isActive: $isActive, 
        name: $name, 
        unit: $unit
        maxQuantity:$maxQuantity,
        personalisationCategory:$personalisationCategory,
        id: $id
        lang:$lang
      }
    ){
      id
    }
  }
`;

export const createPersonalisationCategoryMutation = `
  mutation MyMutation($hotelId: String!, $categoryName: String!) {
    createPersonalisationCategory(input: { hotelId: $hotelId, categoryName: $categoryName }) {
      categoryName
      hotelId
      id
    }
  }
`;

export const updatePersonalisationCategoryMutation = `
  mutation MyMutation($id: String!, $hotelId: String!, $categoryName: String!) {
    updatePersonalisationCategory(input: { id: $id, hotelId: $hotelId, categoryName: $categoryName }) {
      categoryName
      hotelId
      id
    }
  }
`;

export const deletePersonalisationCategoryMutation = `
  mutation MyMutation($hotelId: String!, $id: String!) {
    deletePersonalisationCategory(input: { hotelId: $hotelId, id: $id }) {
      message
      status
    }
  }
`;

export const getPersonalisationCategoriesQuery = `
  query MyQuery($hotelId: String!) {
    getPersonalisationCategories(input: { hotelId: $hotelId }) {
      categoryName
      hotelId
      id
    }
  }
`;

export const createRateFilter = `
mutation MyMutation(
  $code: String!, 
  $displayName: String,
  $description: String, 
  $isActive: Boolean!, 
  $name: String!, 
  $customAttributes:[CustomAttributeInput],
  $rateCodeDescription: String,
  $rateCodes: String,
  $hotelId: String!, 
  $lang:String
  ) {
    createAccommodationRateFilter(
    input: {
      code: $code, 
      displayName: $displayName, 
      description: $description, 
      isActive: $isActive, 
      name: $name, 
      customAttributes:$customAttributes,
      rateCodeDescription:$rateCodeDescription,
      rateCodes:$rateCodes,
      hotelId: $hotelId, 
      lang:$lang
    }
  ){
    id
  }
}
`;

export const updateRateFilter = `
mutation MyMutation(
  $code: String!, 
  $displayName: String,
  $description: String, 
  $isActive: Boolean!, 
  $name: String!, 
  $customAttributes:[CustomAttributeInput],
  $rateCodeDescription: String,
  $rateCodes: String,
  $hotelId: String!, 
  $id: String! 
  $lang:String
  ) {
    updateAccommodationRateFilter(
    input: {
      code: $code, 
      displayName: $displayName, 
      description: $description, 
      isActive: $isActive, 
      name: $name, 
      customAttributes:$customAttributes,
      rateCodeDescription:$rateCodeDescription,
      rateCodes:$rateCodes,
      hotelId: $hotelId, 
      id: $id
      lang:$lang
    }
  ){
    id
  }
}
`;
export const createUpgrade =
  /* GraphQL */
  `
    mutation MyMutation(
      $hotelId: String!
      $roomTypeId: String!
      $upgradeType: [UpgradeItemInput]!
      $lang: String
    ) {
      createUpgrade(
        input: {
          hotelId: $hotelId
          roomTypeId: $roomTypeId
          upgradeType: $upgradeType
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const updateUpgrade =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $hotelId: String!
      $roomTypeId: String!
      $upgradeType: [UpgradeItemInput]!
      $lang: String
    ) {
      updateUpgrade(
        input: {
          id: $id
          hotelId: $hotelId
          roomTypeId: $roomTypeId
          upgradeType: $upgradeType
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const createPackage =
  /* GraphQL */
  `
    mutation MyMutation(
      $code: String!
      $hotelId: String!
      $description: String!
      $name: String!
      $costPerNight: Float!
      $isActive: Boolean!
      $lang: String
    ) {
      createPackage(
        input: {
          code: $code
          hotelId: $hotelId
          description: $description
          name: $name
          costPerNight: $costPerNight
          isActive: $isActive
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const updatePackage =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $code: String!
      $hotelId: String!
      $description: String!
      $name: String!
      $costPerNight: Float!
      $isActive: Boolean!
      $lang: String
    ) {
      updatePackage(
        input: {
          id: $id
          code: $code
          hotelId: $hotelId
          description: $description
          name: $name
          costPerNight: $costPerNight
          isActive: $isActive
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const deleteAccommodationPackage = `
mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deletePackage(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang
      }
    ) {
    status
    }
  }`;

export const deleteAccommodationUpgrade = `
mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deleteUpgrade(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang
      }
    ) {
    status
    }
  }`;

export const deleteAccommodationRoom = `
mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deleteRoom(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang
      }
    ) {
    status
    }
  }`;

export const deleteAccommodationRateFilter = `
  mutation MyMutation(
      $hotelId: String!
      $id: String!
      $lang: String
    ) {
      deleteAccommodationRateFilter(
        input: {
          hotelId: $hotelId
          id: $id
          lang: $lang
        }
      ) {
      status
      }
    }`;

export const deleteAccommodationRoomType = `
mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deleteRoomType(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang
      }
    ) {
    status
    }
  }`;

export const deleteAccommodationFloor = `
mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deleteFloor(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang
      }
    ) {
    status
    }
  }`;

export const deleteAccommodationCategory = `
mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deleteCategory(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang

      }
    ) {
    status
    }
  }`;

export const deleteAccommodationPersonalization = `
mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deletePersonalisation(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang
      }
    ) {
    status
    }
  }`;

// Accommodation Mutation Ends here

export const updateHotelSystemsModuleConfigurations = `
    mutation MyMutation(
      $hotelId: String!
      $hotelServiceModules: [HotelServiceModuleInfoInput]
      $guestRoomExpModules: [GuestRoomExpModuleInfoInput]
      $entertainmentModules: [EntertainmentModulesInfoInput]
    ) {
      updateHotelSystemModulesConfigurations(
        input: {
          hotelId: $hotelId
          hotelServiceModules: $hotelServiceModules
          guestRoomExpModules: $guestRoomExpModules
          entertainmentModules: $entertainmentModules
        }
      ) {
        message
        status
      }
    }
`;

export const updateHotelServiceConfigModules = `
    mutation MyMutation(
      $hotelId: String!
      $hotelServiceModules: [HotelServiceModuleInfoInput]
    ) {
      updateHotelServiceConfigModules(
        input: {
          hotelId: $hotelId
          hotelServiceModules: $hotelServiceModules
        }
      ) {
        message
        status
      }
    }
`;

export const updateEntertainmentConfigModules = `
    mutation MyMutation(
      $hotelId: String!
      $entertainmentModules: [EntertainmentModulesInfoInput]
    ) {
      updateEntertainmentConfigModules(
        input: {
          hotelId: $hotelId
          entertainmentModules: $entertainmentModules
        }
      ) {
        message
        status
      }
    }
`;

export const updateGuestRoomExpConfigModules = `
    mutation MyMutation(
      $hotelId: String!
      $guestRoomExpModules: [GuestRoomExpModuleInfoInput]
    ) {
      updateGuestRoomExpConfigModules(
        input: {
          hotelId: $hotelId
          guestRoomExpModules: $guestRoomExpModules
        }
      ) {
        message
        status
      }
    }
`;
export const createAmenity =
  /* GraphQL */
  `
    mutation MyMutation(
      $categoryIds: [String]!
      $description: String!
      $highlights: [String]
      $hotelId: String!
      $name: String!
      $information: [AmenityInformationInput]!
      $images: [ImagesInput]
      $lang: String
      $customAttributes: [CustomAttributeInput]
    ) {
      createAmenity(
        input: {
          categoryIds: $categoryIds
          description: $description
          highlights: $highlights
          hotelId: $hotelId
          name: $name
          information: $information
          images: $images
          lang: $lang
          customAttributes: $customAttributes
        }
      ) {
        id
      }
    }
  `;

export const updateAmenity =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $categoryIds: [String]!
      $description: String!
      $hotelId: String!
      $name: String!
      $highlights: [String]
      $information: [AmenityInformationInput]!
      $images: [ImagesInput]
      $lang: String
      $customAttributes: [CustomAttributeInput]
    ) {
      updateAmenity(
        input: {
          id: $id
          categoryIds: $categoryIds
          description: $description
          hotelId: $hotelId
          name: $name
          highlights: $highlights
          information: $information
          images: $images
          lang: $lang
          customAttributes: $customAttributes
        }
      ) {
        id
      }
    }
  `;

export const createCategorySection =
  /* GraphQL */
  `
    mutation MyMutation(
      $name: String!
      $hotelId: String!
      $lang: String
      $images: [ImagesInput]
      $customAttributes: [CustomAttributeInput]
    ) {
      createCategorySection(
        input: {
          name: $name
          hotelId: $hotelId
          lang: $lang
          images: $images
          customAttributes: $customAttributes
        }
      ) {
        id
      }
    }
  `;

export const createAmenitiesCategory =
  /* GraphQL */
  `
    mutation MyMutation(
      $sectionId: String
      $sectionIds: [String]
      $name: String!
      $hotelId: String!
      $lang: String
      $images: [ImagesInput]
      $customAttributes: [CustomAttributeInput]
    ) {
      createAmenitiesCategory(
        input: {
          sectionIds: $sectionIds
          sectionId: $sectionId
          name: $name
          hotelId: $hotelId
          lang: $lang
          images: $images
          customAttributes: $customAttributes
        }
      ) {
        id
      }
    }
  `;

export const updateAmenitiesCategory =
  /* GraphQL */
  `
    mutation MyMutation(
      $sectionIds: [String]
      $name: String!
      $hotelId: String!
      $id: String!
      $lang: String
      $images: [ImagesInput]
      $customAttributes: [CustomAttributeInput]
    ) {
      updateAmenitiesCategory(
        input: {
          sectionIds: $sectionIds
          name: $name
          hotelId: $hotelId
          id: $id
          lang: $lang
          images: $images
          customAttributes: $customAttributes
        }
      ) {
        id
      }
    }
  `;

export const updateCategorySection =
  /* GraphQL */
  `
    mutation MyMutation(
      $name: String!
      $hotelId: String!
      $id: String!
      $lang: String
      $images: [ImagesInput]
      $customAttributes: [CustomAttributeInput]
    ) {
      updateCategorySection(
        input: {
          name: $name
          hotelId: $hotelId
          id: $id
          lang: $lang
          images: $images
          customAttributes: $customAttributes
        }
      ) {
        id
      }
    }
  `;
export const deleteAmenity = `
  mutation DeleteAmenity(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deleteAmenity(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang 
      }
    ) {
    status
    }
  }
  `;

export const activateAmenity = `
  mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    activateAmenity(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang 
      }
    ) {
    status
    }
  }`;

export const deactivateAmenity = `
  mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deactivateAmenity(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang 
      }
    ) {
    status
    }
  }`;

export const deleteAmenityCategory = `
  mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deleteAmenitiesCategory(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang
      }
    ) {
    status
    }
  }
  `;

export const deleteCategorySection = `
  mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deleteCategorySection(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang
      }
    ) {
    status
    }
  }
  `;
export const saveGlobalDefaultConfigs =
  /* GraphQL */
  `
    mutation MyMutation(
      $hotelId: String!
      $hostingPref: String
      $id: String!
      $languages: [LanguageInput]
      $serverConfigType: String!
    ) {
      saveGlobalDefaultConfigs(
        input: {
          hostingPref: $hostingPref
          hotelId: $hotelId
          id: $id
          languages: $languages
          serverConfigType: $serverConfigType
        }
      ) {
        message
        status
      }
    }
  `;

export const saveGlobalDdkConfigs =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $code: String!
      $hotelId: String!
      $protocol: [String]!
      $provider: String!
    ) {
      saveGlobalDdkConfigs(
        input: { code: $code, hotelId: $hotelId, id: $id, protocol: $protocol, provider: $provider }
      ) {
        message
        status
      }
    }
  `;

export const saveGlobalDndConfigs =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $code: String!
      $hotelId: String!
      $protocol: [String]!
      $provider: String!
    ) {
      saveGlobalDndConfigs(
        input: { code: $code, hotelId: $hotelId, id: $id, protocol: $protocol, provider: $provider }
      ) {
        message
        status
      }
    }
  `;

export const saveGlobalMmrConfigs =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $code: String!
      $hotelId: String!
      $protocol: [String]!
      $provider: String!
    ) {
      saveGlobalMmrConfigs(
        input: { code: $code, hotelId: $hotelId, id: $id, protocol: $protocol, provider: $provider }
      ) {
        message
        status
      }
    }
  `;

export const inviteUserReq = `
  mutation MyMutation(
      $brandId: String
      $departmentId: String
      $email: String!
      $employeeId: String
      $firstName: String
      $groupId: String
      $hotelId: String
      $lastName: String
      $phoneNumber: String
      $imageUrl: String
      $role: roleInput
      $roles: [String]
      $restaurantId: String
    ) {
    inviteUser(
      input: {
        brandId: $brandId,
        departmentId: $departmentId,
        email: $email, 
        employeeId: $employeeId, 
        firstName: $firstName, 
        groupId: $groupId, 
        hotelId: $hotelId, 
        lastName: $lastName, 
        phoneNumber: $phoneNumber, 
        imageUrl: $imageUrl, 
        role: $role,
        roles: $roles,
        restaurantId: $restaurantId
    }) {
      id
    }
  }
`;

export const editUser = `
mutation MyMutation(
  $brandId: String
  $departmentId: String
  $employeeId: String
  $firstName: String
  $groupId: String
  $hotelId: String
  $lastName: String
  $phoneNumber: String
  $imageUrl: String
  $role: roleInput
  $roles: [String]
  $id: String!
  $restaurantId: String
) {
  editUser(
  input: {
    brandId: $brandId,
    departmentId: $departmentId,
    employeeId: $employeeId, 
    firstName: $firstName, 
    groupId: $groupId, 
    hotelId: $hotelId, 
    lastName: $lastName, 
    phoneNumber: $phoneNumber, 
    imageUrl: $imageUrl, 
    role: $role,
    roles: $roles,
    restaurantId: $restaurantId
    id: $id
}) {
  id
}
}
`;

export const deactivateUser = `
  mutation MyMutation(
    $id: String!
  ) {
    deactivateUser(id: $id) {
      id
    }
  }
`;

export const reactivateUser = `
  mutation MyMutation(
    $id: String!
  ) {
    reactivateUser(id: $id) {
      id
    }
  }
`;

export const resendInvite = `
  mutation MyMutation(
    $id: String!
  ) {
    resendInvite(id: $id) {
      id
    }
  }
`;

export const addRestaurant = `
mutation MyMutation(
  $code:String!
  $venueGroupId: String!
  $awards:String
  $description: String!
  $additionalInformation: String
  $type: String!
  $name: String!
  $menu: String!
  $customAttributes : [CustomAttributeInput]
  $hours: [RestaurantHoursInput]
  $contactNumber: String!
  $email: String!
  $contact: [ContactDetailsInput]
  $mediaContent: [CustomAttributeInput]
  $location: RestaurantLocationInput!
  $images: [ImagesInput]
  $hotelId: String!
  $primaryCuisine: String!
  $secondaryCuisine: [String]!
  $menuStatus:String
  $ctaTitle:String
  $cta:RestaurantCtaInput
  $isActive: Boolean!
  $cuisine: String!
  $lang: String
  $additionalMenu: [AdditionalMenuInput]
  ) {
  createRestaurant(
    input: {
      code: $code
      contactNumber: $contactNumber
      email: $email
      contact: $contact
      venueGroupId: $venueGroupId
      awards: $awards
      description: $description
      additionalInformation: $additionalInformation
      hotelId: $hotelId
      hours: $hours
      menu: $menu
      customAttributes : $customAttributes
      name: $name
      type: $type
      images: $images
      mediaContent: $mediaContent
      location: $location
      primaryCuisine: $primaryCuisine
      secondaryCuisine: $secondaryCuisine
      menuStatus:$menuStatus
      ctaTitle:$ctaTitle
      cta:$cta
      isActive: $isActive
      cuisine: $cuisine
      lang: $lang
      additionalMenu: $additionalMenu
    }
  ) {
    id
  }
}
`;

export const updateRestaurant = `
mutation MyMutation(
  $code:String!
  $cuisine: String!
  $venueGroupId: String!
  $awards:String!
  $description: String!
  $additionalInformation: String!
  $type: String!
  $name: String!
  $menu: String!
  $customAttributes : [CustomAttributeInput]
  $hours: [RestaurantHoursInput]
  $contactNumber: String!
  $email: String!
  $contact: [ContactDetailsInput]
  $location: RestaurantLocationInput!
  $images: [ImagesInput]
  $mediaContent: [CustomAttributeInput]
  $hotelId: String!
  $id: String!
  $primaryCuisine: String!
  $secondaryCuisine: [String]!
  $menuStatus:String
  $ctaTitle:String
  $cta:RestaurantCtaInput
  $isActive: Boolean!
  $lang: String
  $additionalMenu: [AdditionalMenuInput]
  ) {
    updateRestaurant(
    input: {
      code: $code
      contactNumber: $contactNumber
      cuisine: $cuisine
      email: $email
      contact: $contact
      venueGroupId: $venueGroupId
      awards: $awards
      description: $description
      additionalInformation: $additionalInformation
      hotelId: $hotelId
      hours: $hours
      menu: $menu
      customAttributes : $customAttributes
      name: $name
      type: $type
      mediaContent: $mediaContent
      images: $images
      location: $location
      id:$id
      primaryCuisine: $primaryCuisine
      secondaryCuisine: $secondaryCuisine
      menuStatus:$menuStatus
      ctaTitle:$ctaTitle
      cta:$cta
      isActive: $isActive
      lang: $lang
      additionalMenu: $additionalMenu
    }
  ) {
    id
  }
}
`;

export const dataSortMapping = `
mutation MyMutation(
  $hotelId:String! 
  $jsonResponse: String!
  $lang: String!
  $module: String!
  ) {
  createDataSortMapping(
    input: {
      hotelId:$hotelId 
      jsonResponse:$jsonResponse
      lang: $lang
      module: $module
    }) {
    message
    status
  }
}
`;

export const updateLiveTvOrder = `
mutation MyMutation(
  $hotelId:String! 
  $channels: [UpdateLiveTvOrderChannels]!
  ) {
    updateLiveTvOrder(
    input: {
      hotelId:$hotelId 
      channels:$channels
    }) {
    message
    status
  }
}
`;

export const sortChannel = `
mutation MyMutation(
  $hotelId:String! 
  $isSort: Boolean!
  ) {
    sortChannel(
    input: {
      isSort:$isSort 
      hotelId:$hotelId
    }) {
    message
    status
  }
}
`;

export const addChef = `
  mutation MyMutation(
    $restaurantId:String!
    $name:String!
    $designation:String!
    $specisalisation:String!
    $signatureDish:String!
    $description:String!
    $email:String
    $phone:String
    $images:[ImagesInput]
    $hotelId:String!
    $lang: String
    $mediaContent: [CustomAttributeInput]
    ) {
    createChef(
      input: {
        restaurantId: $restaurantId
        name: $name
        designation:$designation
        specisalisation:$specisalisation
        signatureDish:$signatureDish
        description:$description
        email:$email
        phone:$phone
        images:$images
        hotelId:$hotelId
        lang: $lang
        mediaContent: $mediaContent
      }
    ) {
      id
    }
  }
`;

export const updateChef = `
  mutation MyMutation(
    $restaurantId:String!
    $name:String!
    $designation:String!
    $specisalisation:String!
    $signatureDish:String!
    $description:String!
    $email:String
    $phone:String
    $images:[ImagesInput]
    $hotelId:String!
    $id:String!
    $lang: String
    $mediaContent: [CustomAttributeInput]
    ) {
    updateChef(
      input: {
        restaurantId: $restaurantId
        name: $name
        designation:$designation
        specisalisation:$specisalisation
        signatureDish:$signatureDish
        description:$description
        email:$email
        phone:$phone
        images:$images
        hotelId:$hotelId
        id:$id
        lang: $lang
        mediaContent: $mediaContent
      }
    ) {
      id
    }
  }
`;

export const deleteChef = `
mutation MyMutation(
  $hotelId:String! 
  $id:String!
  $lang: String
  
  ) {
  deleteChef(
    input: {
      hotelId:$hotelId 
      id:$id
      lang: $lang
    }) {
    message
    status
  }
}
`;

export const deleteRestaurant = `
mutation MyMutation(
  $hotelId:String! 
  $id:String!
  $lang: String
  
  ) {
    deleteRestaurant(
    input: {
      hotelId:$hotelId 
      id:$id
      lang: $lang
    }) {
    message
    status
  }
}
`;

export const addIRDCategory = `
mutation MyMutation(
  $name:String!
  $code:String!
  $description:String!
  $customAttributes : [CustomAttributeInput]
  $hotelId:String!
  $restaurantId:String!
  $status:Boolean!
  $hours: IRDCategoryHoursInput!
  $images:[ImagesInput]
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  createIRDCategory(input: {
      hotelId: $hotelId
      restaurantId: $restaurantId
      code: $code
      name: $name
      status: $status
      description: $description
      customAttributes : $customAttributes
      hours: $hours
      images: $images
      lang: $lang
      mediaContent: $mediaContent
  }) {
    id
  }
}
`;

export const uploadIRDCategoryByCSV = `
mutation MyMutation(
  $hotelId:String!
  $lang: String
  $isReplace: Boolean
  $category: [IRDCategoryCreateInput]!
  $restaurantId:String
) {
  uploadIRDCategoryByCSV(input: {
  category: $category,
  hotelId:$hotelId,
  isReplace: $isReplace,
  lang: $lang,
  restaurantId: $restaurantId
  }) {
    duplicates {
      customAttributes {
        key
        value
      }
      hotelId
      lang
      restaurantId
      name
      status
    }
    hotelId
    status
  }
}
`;

export const uploadIRDBundleByCSV = `
mutation MyMutation(
  $hotelId:String!
  $lang: String
  $isReplace: Boolean
  $bundles: [IRDBundleCreateInput]!
  $restaurantId:String
) {
  uploadIRDBundleByCSV(input: {
  bundles: $bundles,
  hotelId:$hotelId,
  IsReplace: $isReplace,
  lang: $lang,
  restaurantId: $restaurantId
  }) {
    duplicates {
      addons {
        addons
        groupedAddon {
          addons
          limit
          title
        }
        limit
        type
        value
      }
      code
      customAttributes {
        key
        value
      }
      description
      hotelId
      items
      lang
      name
      price
      restaurantId
      status
      upsell {
        items
        status
      }
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
    }
    hotelId
    status
  }
}
`;

export const uploadIRDItemsByCSV = `
mutation MyMutation(
  $hotelId:String!
  $lang: String
  $isReplace: Boolean
  $items: [IRDItemCreateInput]!
  $restaurantId:String
) {
  uploadIRDItemsByCSV(input: {
  items: $items,
  hotelId:$hotelId,
  isReplace: $isReplace,
  lang: $lang,
  restaurantId: $restaurantId
  }) {
    duplicates {
      addons {
        addons
        groupedAddon {
          addons
          limit
          title
        }
        limit
        type
        value
      }
      allergens
      code
      customAttributes {
        key
        value
      }
      customisation {
        ingredients {
          customisations
          ingredient
        }
        status
      }
      description
      discount {
        discount
        status
      }
      hotelId
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
      ingredients
      lang
      name
      price
      restaurantId
      status
      tags
      type
      upsell {
        items
        status
      }
    }
    hotelId
    status
  }
}
`;

export const uploadIRDCustomisationsByCSV = `
mutation MyMutation(
  $hotelId:String!
  $lang: String
  $isReplace: Boolean
  $customisations: [IRDCustomisationCreateInput]!
  $restaurantId:String,
) {
  uploadIRDCustomisationsByCSV(input: {
  customisations: $customisations,
  hotelId:$hotelId,
  isReplace: $isReplace,
  lang: $lang,
  restaurantId: $restaurantId
  }) {
    duplicates {
      code
      customAttributes {
        key
        value
      }
      hotelId
      lang
      name
      restaurantId
      status
    }
    hotelId
    status
  }
}
`;

export const uploadIRDTagsByCSV = `
mutation MyMutation(
  $hotelId:String!
  $lang: String
  $isReplace: Boolean
  $tags: [IRDTagCreateInput]!
  $restaurantId:String
) {
  uploadIRDTagsByCSV(input: {
  tags: $tags,
  hotelId:$hotelId,
  isReplace: $isReplace,
  lang: $lang,
  restaurantId: $restaurantId
  }) {
    duplicates {
      code
      customAttributes {
        key
        value
      }
      hotelId
      lang
      name
      restaurantId
      status
    }
    hotelId
    status
  }
}
`;

export const uploadIRDAllergensByCSV = `
mutation MyMutation(
  $hotelId:String!
  $lang: String
  $isReplace: Boolean
  $allergens: [IRDAllergenCreateInput]!
  $restaurantId:String
) {
  uploadIRDAllergensByCSV(input: {
  allergens: $allergens,
  hotelId:$hotelId,
  isReplace: $isReplace,
  lang: $lang,
  restaurantId: $restaurantId
  }) {
    duplicates {
      code
      hotelId
      lang
      name
      restaurantId
      status
      customAttributes {
        key
        value
      }
    }
    hotelId
    status
  }
}
`;

export const uploadIRDDiscountByCSV = `
mutation MyMutation(
  $hotelId:String!
  $lang: String
  $isReplace: Boolean
  $discounts: [IRDDiscountCreateInput]!
  $restaurantId:String
) {
  uploadIRDDiscountByCSV(input: {
  discounts: $discounts,
  hotelId:$hotelId,
  isReplace: $isReplace,
  lang: $lang,
  restaurantId: $restaurantId
  }) {
    duplicates {
      code
      hotelId
      lang
      name
      restaurantId
      status
      value
      upto
    }
    hotelId
    status
  }
}
`;

export const uploadIRDAddonsByCSV = `
mutation MyMutation(
  $hotelId:String!
  $lang: String
  $isReplace: Boolean
  $addons: [IRDAddonCreateInput]!
  $restaurantId:String
) {
  uploadIRDAddonsByCSV(input: {
  addons: $addons,
  hotelId:$hotelId,
  isReplace: $isReplace,
  lang: $lang,
  restaurantId: $restaurantId
  }) {
    duplicates {
      code
      customAttributes {
        key
        value
      }
      hotelId
      lang
      name
      price
      restaurantId
      status
    }
    hotelId
    status
  }
}
`;

export const addSpa = `
mutation CreateSpa(
  $code: String!
  $name: String!
  $description: String!
  $isActive: Boolean!
  $treatmentsMenu: String!
  $customAttributes : [CustomAttributeInput]
  $hours: SpaHoursInput!
  $contact: SpaContactInput!
  $cta:SpaCTAInput
  $location: SpaLocationInput!
  $images:[ImagesInput]
  $hotelId:String!
  $lang: String
  $mediaContent: [CustomAttributeInput]
  ) {
  createSpa(
    input: {
    code: $code
    name: $name
    description: $description
    isActive: $isActive
    treatmentsMenu: $treatmentsMenu
    customAttributes : $customAttributes
    hours: $hours
    location: $location
    images: $images
    contact: $contact
    cta: $cta
    hotelId: $hotelId
    lang:$lang
    mediaContent: $mediaContent
    }
  ) {
    id
  }
}  
`;

export const updateSpa = `
mutation UpdateSpa(
  $code: String!
  $name: String!
  $description: String!
  $isActive: Boolean!
  $treatmentsMenu: String!
  $customAttributes : [CustomAttributeInput]
  $hours: SpaHoursInput!
  $contact: SpaContactInput!
  $location: SpaLocationInput!
  $images:[ImagesInput]!
  $hotelId:String!
  $id: String!
  $cta:SpaCTAInput
  $lang: String
  $mediaContent: [CustomAttributeInput]
  ) {
  updateSpa(
    input: {
    code: $code
    name: $name
    description: $description
    isActive: $isActive
    treatmentsMenu: $treatmentsMenu
    customAttributes : $customAttributes
    hours: $hours
    location: $location
    contact: $contact
    images: $images
    hotelId: $hotelId
    cta:$cta
    id: $id
    lang:$lang
    mediaContent: $mediaContent
    }
  ) {
    id
  }
}  
`;

export const deleteSpa = `
mutation DeleteSpa(
  $hotelId: String!
  $id: String!
  $lang: String
) {
  deleteSpa(
    input: {
      hotelId: $hotelId
      id: $id
      lang:$lang

    }
  ) {
  message
  status
  }
} 
`;

export const createSpaCategory = `
mutation CreateSpaCategory(
  $name: String!
  $code: String!
  $spaId: String!
  $hotelId: String!
  $lang: String
  $images:[ImagesInput]
  $customAttributes : [CustomAttributeInput]
  $mediaContent: [CustomAttributeInput]
) {
  createSpaCategory(
    input: {
      code: $code,
      name: $name, 
      spaId: $spaId, 
      hotelId: $hotelId 
      lang:$lang
      images: $images
      customAttributes : $customAttributes
      mediaContent: $mediaContent
    }
  ) {
    id
  }
}
`;

export const updateSpaCategory = `
mutation UpdateSpaCategory(
  $name: String!
  $code: String!
  $id: String!
  $spaId: String!
  $hotelId: String!
  $lang: String
  $images:[ImagesInput]
  $customAttributes : [CustomAttributeInput]
  $mediaContent: [CustomAttributeInput]
) {
  updateSpaCategory(
    input: {
      code: $code,
      name: $name, 
      id: $id, 
      spaId: $spaId, 
      hotelId: $hotelId 
      lang:$lang
      images: $images
      customAttributes : $customAttributes
      mediaContent: $mediaContent
    }
  ) {
   id
  }
}
`;

export const deleteSpaCategory = `
mutation DeleteSpaCategory(
  $hotelId: String!
  $id: String!
  $lang: String
) {
  deleteSpaCategory(
    input: {
      hotelId: $hotelId
      id: $id
      lang:$lang
    }
  ) {
  message
  status
  }
}
`;

export const addSpaTreatment = `
mutation CreateSpaTreatment (
  $code: String!
  $name: String!
  $redirectUrl : String!
  $description: String!
  $isActive: Boolean!
  $customAttributes : [CustomAttributeInput]
  $disclaimer: String!
  $hotelId: String!
  $spaId: String!
  $spaCategoryId: String!
  $images: [ImagesInput]
  $type: EnumSpaTreatmentType!
  $duration: [SpaTreatmentDurationInput]!
  $lang: String
  $mediaContent: [CustomAttributeInput]
){
  createSpaTreatment(
    input: {
      hotelId: $hotelId
      spaId: $spaId
      spaCategoryId: $spaCategoryId
      code: $code
      name: $name
      redirectUrl : $redirectUrl
      description: $description
      isActive: $isActive
      customAttributes : $customAttributes
      disclaimer: $disclaimer
      type: $type
      duration: $duration
      images: $images
      lang:$lang
      mediaContent: $mediaContent
    }
  ) {
    id
  }
}
`;

export const editIRDCategory = `
mutation MyMutation(
  $id:String!
  $name:String!
  $code:String!
  $description:String!
  $customAttributes : [CustomAttributeInput]
  $hotelId:String!
  $restaurantId:String!
  $status:Boolean!
  $hours: IRDCategoryHoursInput!
  $images:[ImagesInput]
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  updateIRDCategory(input: {
      id: $id
      hotelId: $hotelId
      restaurantId: $restaurantId
      code: $code
      name: $name
      status: $status
      description: $description
      customAttributes : $customAttributes
      hours: $hours
      images: $images
      lang: $lang
      mediaContent: $mediaContent
  }) {
    id
  }
}
`;

export const updateSpaTreatment = `
mutation UpdateSpaTreatment (
  $code: String!
  $name: String!
  $redirectUrl : String!
  $description: String!
  $isActive: Boolean!
  $customAttributes : [CustomAttributeInput]
  $disclaimer: String!
  $hotelId: String!
  $spaId: String!
  $spaCategoryId: String!
  $images: [ImagesInput]!
  $type:EnumSpaTreatmentType!
  $duration: [SpaTreatmentDurationInput]!
  $id: String!
  $lang: String
  $mediaContent: [CustomAttributeInput]
){
  updateSpaTreatment(
    input: {
      hotelId: $hotelId
      spaId: $spaId
      spaCategoryId: $spaCategoryId
      code: $code
      name: $name
      redirectUrl : $redirectUrl
      description: $description
      isActive: $isActive
      customAttributes : $customAttributes
      disclaimer: $disclaimer
      type: $type
      duration: $duration
      images: $images
      id: $id
      lang:$lang
      mediaContent: $mediaContent
    }
  ) {
    id
  }
}
`;

export const deleteSpaTreatment = `
mutation DeleteSpaTreatment(
  $hotelId: String!
  $id: String!
  $lang: String
) {
  deleteSpaTreatment(
    input: {
      hotelId: $hotelId
      id: $id
      lang:$lang
    }
  ) {
  message
  status
  }
}
`;

export const createHouseKeepingService = `mutation MyMutation(
  $name: String!
  $code: String!
  $description: String
  $icon: String!
  $confirmationMessage: String
  $isActive: Boolean!
  $maxQuantity:Int
  $maxQuantityActive:Boolean!
  $schedule: [EnumScheduleTypes]
  $scheduleActive:Boolean!
  $hotelId: String!
  $itemList : [ServiceRequestItemInput]
  $hours: [ServiceRequestHoursInput]
  $customAttributes : [CustomAttributeInput]
  $images: [ImagesInput]
  $isItemActive: Boolean
  $customSchedule: String
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  createHouseKeeping(
    input: {
      code:$code
      description:$description
      icon: $icon
      confirmationMessage:$confirmationMessage
      hotelId:$hotelId
      isItemActive: $isItemActive
      isActive: $isActive
      maxQuantityActive: $maxQuantityActive
      name:$name
      schedule: $schedule
      scheduleActive: $scheduleActive
      maxQuantity: $maxQuantity
      items: $itemList
      images: $images
      hours: $hours
      customAttributes : $customAttributes
      customSchedule: $customSchedule
      lang: $lang
      mediaContent: $mediaContent
    }
  ) {
    id
  }
}`;

export const createConcierge = `mutation MyMutation(
  $name: String!
  $code: String!
  $description: String
  $icon: String!
  $confirmationMessage: String
  $resident:Boolean!
  $isActive: Boolean!
  $maxQuantity:Int
  $maxQuantityActive:Boolean!
  $schedule: [EnumScheduleTypes]
  $scheduleActive:Boolean!
  $hotelId: String!
  $itemList : [ServiceRequestItemInput]
  $hours: [ServiceRequestHoursInput]
  $images: [ImagesInput]
  $isItemActive: Boolean
  $customSchedule: String
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  createConcierge(
    input: {
      code:$code
      description:$description
      confirmationMessage:$confirmationMessage
      hotelId:$hotelId
      icon: $icon
      isItemActive: $isItemActive
      isActive: $isActive
      resident: $resident
      maxQuantityActive: $maxQuantityActive
      name:$name
      schedule: $schedule
      scheduleActive: $scheduleActive
      maxQuantity: $maxQuantity
      items: $itemList
      images: $images
      hours: $hours
      customSchedule: $customSchedule
      lang: $lang
      mediaContent: $mediaContent
    }
  ) {
    id
  }
}`;

export const updateHouseKeeping = `mutation MyMutation(
  $id: String!
  $name: String!
  $code: String!
  $description: String!
  $icon: String!
  $confirmationMessage: String!
  $maxQuantity:Int
  $isActive: Boolean!
  $maxQuantityActive:Boolean!
  $schedule: [EnumScheduleTypes]
  $scheduleActive:Boolean!
  $hotelId: String!
  $itemList : [ServiceRequestItemInput]
  $hours: [ServiceRequestHoursInput]
  $customAttributes : [CustomAttributeInput]
  $images: [ImagesInput]
  $isItemActive: Boolean
  $customSchedule: String
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  updateHouseKeeping(
    input: {
      id:$id
      code:$code
      description:$description
      icon: $icon
      confirmationMessage:$confirmationMessage
      hotelId:$hotelId
      isItemActive: $isItemActive
      isActive: $isActive
      maxQuantityActive: $maxQuantityActive
      name:$name
      schedule: $schedule
      scheduleActive: $scheduleActive
      maxQuantity: $maxQuantity
      items: $itemList
      images: $images
      hours: $hours
      customAttributes : $customAttributes
      customSchedule: $customSchedule
      lang: $lang
      mediaContent: $mediaContent
    }
  ) {
    id
  }
}`;

export const updateConcierge = `mutation MyMutation(
  $id:String!
  $name: String!
  $code: String!
  $description: String!
  $icon: String!
  $confirmationMessage: String!
  $resident:Boolean!
  $isActive: Boolean!
  $maxQuantity:Int
  $maxQuantityActive:Boolean!
  $schedule: [EnumScheduleTypes]!
  $scheduleActive:Boolean!
  $hotelId: String!
  $itemList : [ServiceRequestItemInput]
  $hours: [ServiceRequestHoursInput]
  $images: [ImagesInput]!
  $isItemActive: Boolean
  $customSchedule: String
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  updateConcierge(
    input: {
      id:$id
      code:$code
      description:$description
      confirmationMessage:$confirmationMessage
      hotelId:$hotelId
      icon: $icon
      isItemActive: $isItemActive
      isActive: $isActive
      resident: $resident
      maxQuantityActive: $maxQuantityActive
      name:$name
      schedule: $schedule
      scheduleActive: $scheduleActive
      maxQuantity: $maxQuantity
      items: $itemList 
      images: $images
      hours: $hours
      customSchedule: $customSchedule
      lang: $lang
      mediaContent: $mediaContent
    }
  ) {
    id
  }
}`;

export const deleteHouseKeeping = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    deleteHouseKeeping(input: {hotelId: $hotelId, id: $id, lang: $lang}) {
      message
      status
    }
}`;

export const deleteConcierge = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    deleteConcierge(input: {hotelId: $hotelId, id: $id, lang: $lang}) {
      message
      status
    }
}`;

export const activateHouseKeeping = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    activateHouseKeeping(input: {hotelId: $hotelId, id: $id, lang: $lang}) {
      message
      status
    }
}`;

export const activateConcierge = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    activateConcierge(input: {hotelId: $hotelId, id: $id, lang:$lang}) {
      message
      status
    }
}`;

export const deactivateHouseKeeping = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    deactivateHouseKeeping(input: {hotelId: $hotelId, id: $id, lang:$lang}) {
      message
      status
    }
}`;

export const deactivateAccommodationPackage = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    disablePackages(input: {hotelId: $hotelId, id: $id, lang:$lang}) {
      message
      status
    }
}`;

export const activateAccommodationPackage = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    enablePackages(input: {hotelId: $hotelId, id: $id, lang:$lang}) {
      message
      status
    }
}`;

export const activateAccommodationPersonalization = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    enablePersonalisation(input: {hotelId: $hotelId, id: $id, lang:$lang}) {
      message
      status
    }
}`;

export const deactivateAccommodationPersonalization = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    disablePersonalisation(input: {hotelId: $hotelId, id: $id, lang:$lang}) {
      message
      status
    }
}`;

export const activateAccommodationRoomType = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    enableRoomType(input: {hotelId: $hotelId, id: $id, lang:$lang}) {
      message
      status
    }
}`;

export const deactivateAccommodationRoomType = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    disableRoomType(input: {hotelId: $hotelId, id: $id, lang:$lang}) {
      message
      status
    }
}`;

export const deactivateConcierge = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    deactivateConcierge(input: {hotelId: $hotelId, id: $id, lang:$lang}) {
      message
      status
    }
}`;

export const deactivateIRDCategory = `
mutation MyMutation(
  $id:String!
  $hotelId:String!
  $restaurantId:String
  $lang: String
  ) {
  disableIRDCategory(
    input: {
      id: $id
      hotelId: $hotelId
      restaurantId: $restaurantId
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;
export const activateIRDCategory = `
mutation MyMutation(
  $id:String!
  $hotelId:String!
  $restaurantId:String
  $lang: String
  ) {
  enableIRDCategory(
    input: {
      id:$id
      hotelId: $hotelId
      restaurantId: $restaurantId
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;
export const deleteIRDCategory = `
mutation MyMutation(
  $id:String!
  $hotelId:String!
  $restaurantId:String
  $lang: String
){
  deleteIRDCategory(
    input: {
      id:$id
      hotelId: $hotelId
      restaurantId: $restaurantId
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const addIRDItem = `
mutation CreateIRDItem(
  $hotelId: String!
  $restaurantId: String
  $status: Boolean!
  $type: String!
  $code: String!
  $name: String!
  $price: Float!
  $description: String!
  $ingredients: String!
  $allergens: [String]!
  $tags: [String]!
  $addons: IRDAddonsInput!
  $customisation: IRDItemCustomisationInput!
  $upsell: IRDUpsellInput!
  $discount: IRDItemDiscountInput!
  $images: [ImagesInput]
  $customAttributes : [CustomAttributeInput]
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  createIRDItem(
    input: {
      hotelId: $hotelId
      restaurantId: $restaurantId
      code: $code
      name: $name
      status: $status
      type: $type
      price: $price
      description: $description
      ingredients: $ingredients
      allergens: $allergens
      tags: $tags
      addons: $addons
      customisation: $customisation
      upsell: $upsell
      discount: $discount
      images: $images
      customAttributes : $customAttributes
      lang:$lang
      mediaContent: $mediaContent
    }
  ) {
    id
  }
}
`;

export const editIRDItem = `
mutation UpdateIRDItem(
  $id: String!
  $hotelId: String!
  $restaurantId: String
  $status: Boolean!
  $type: String!
  $code: String!
  $name: String!
  $price: Float!
  $description: String!
  $ingredients: String!
  $allergens: [String]!
  $tags: [String]!
  $addons: IRDAddonsInput!
  $customisation: IRDItemCustomisationInput!
  $upsell: IRDUpsellInput!
  $discount: IRDItemDiscountInput!
  $images: [ImagesInput]
  $customAttributes : [CustomAttributeInput]
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  updateIRDItem(
    input: {
      id: $id
      hotelId: $hotelId
      restaurantId: $restaurantId
      code: $code
      name: $name
      status: $status
      type: $type
      price: $price
      description: $description
      ingredients: $ingredients
      allergens: $allergens
      tags: $tags
      addons: $addons
      customisation: $customisation
      upsell: $upsell
      discount: $discount
      images: $images
      customAttributes : $customAttributes
      lang:$lang
      mediaContent: $mediaContent
    }
  ) {
    id
  }
}
`;

export const deleteIRDItem = `
mutation DeleteIRDItem(
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  deleteIRDItem(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id 
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const enableIRDItem = `
mutation EnableIRDItem (
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  enableIRDItem(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id 
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const disableIRDItem = `
mutation DisableIRDItem (
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  disableIRDItem(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id 
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const addIRDTag = `
mutation CreateIRDTag(
  $hotelId: String!
  $restaurantId: String
  $code: String!
  $name: String!
  $customAttributes : [CustomAttributeInput]
  $status: Boolean
  $lang: String
) {
  createIRDTag(
    input: {
      hotelId: $hotelId
      restaurantId: $restaurantId
      code: $code
      name: $name
      customAttributes : $customAttributes
      status:$status 
      lang:$lang
    }
  ) {
    id
  }
}
`;

export const editIRDTag = `
mutation UpdateIRDTag(
  $id: String!
  $hotelId: String!
  $restaurantId: String
  $code: String!
  $name: String!
  $customAttributes : [CustomAttributeInput]
  $status: Boolean
  $lang: String
) {
  updateIRDTag(
    input: {
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id
      code: $code
      name: $name
      customAttributes : $customAttributes
      status:$status 
      lang:$lang
    }
  ) {
    id
  }
}
`;

export const deleteIRDTag = `
mutation DeleteIRDTag(
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  deleteIRDTag(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id
      lang:$lang
     }
    ) {
    status
    message
  }
}
`;

export const enableIRDTag = `
mutation MyMutation (
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  enableIRDTag(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id 
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const disableIRDTag = `
mutation MyMutation (
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  disableIRDTag(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id 
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const addIRDAllergen = `
mutation CreateIRDAllergen(
  $hotelId: String!
  $restaurantId: String
  $code: String!
  $name: String!
  $customAttributes : [CustomAttributeInput]
  $status: Boolean
  $lang: String
) {
  createIRDAllergen(
    input: {
      hotelId: $hotelId
      restaurantId: $restaurantId
      code: $code
      name: $name
      customAttributes : $customAttributes
      status: $status
      lang:$lang
    }
  ) {
    id
  }
}
`;

export const editIRDAllergen = `
mutation UpdateIRDAllergen(
  $id: String!
  $hotelId: String!
  $restaurantId: String
  $code: String!
  $name: String!
  $customAttributes : [CustomAttributeInput]
  $status: Boolean
  $lang: String
) {
  updateIRDAllergen(
    input: {
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id
      code: $code
      name: $name
      customAttributes : $customAttributes
      status: $status
      lang:$lang
    }
  ) {
    id
  }
}
`;

export const deleteIRDAllergen = `
mutation DeleteIRDAllergen(
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  deleteIRDAllergen(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id
      lang:$lang
     }
    ) {
    status
    message
  }
}
`;

export const enableIRDAllergen = `
mutation MyMutation (
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  enableIRDAllergen(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id 
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const disableIRDAllergen = `
mutation MyMutation (
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  disableIRDAllergen(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id 
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const addIRDAddOn = `
mutation CreateIRDAddon(
  $hotelId: String!
  $restaurantId: String
  $code: String!
  $name: String!
  $status: Boolean!
  $price: Int!
  $customAttributes : [CustomAttributeInput]
  $lang: String
  $priceInDecimal: Float
) {
  createIRDAddon(
    input: {
      hotelId: $hotelId
      restaurantId: $restaurantId
      code: $code
      name: $name
      status: $status
      price: $price
      customAttributes : $customAttributes
      lang:$lang
      priceInDecimal: $priceInDecimal
    }
  ) {
    id
  }
}
`;

export const editIRDAddOn = `
mutation UpdateIRDAddon(
  $id: String!
  $hotelId: String!
  $restaurantId: String
  $code: String!
  $name: String!
  $status: Boolean!
  $price: Int!
  $customAttributes : [CustomAttributeInput]
  $lang: String
  $priceInDecimal: Float
) {
  updateIRDAddon(
    input: {
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id
      code: $code
      name: $name
      status: $status
      price: $price
      customAttributes : $customAttributes
      lang:$lang
      priceInDecimal: $priceInDecimal
    }
  ) {
    id
  }
}
`;

export const deleteIRDAddOn = `
mutation DeleteIRDAddon(
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  deleteIRDAddon(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id
      lang:$lang
     }
    ) {
    status
    message
  }
}
`;

export const enableIRDAddOn = `
mutation EnableIRDAddon (
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  enableIRDAddon(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id 
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const disableIRDAddOn = `
mutation DisableIRDAddon (
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  disableIRDAddon(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id 
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;
export const addIRDCustomisation = `
mutation MyMutation(
  $name:String!
  $code:String!
  $status:Boolean!
  $hotelId:String!
  $restaurantId:String
  $customAttributes : [CustomAttributeInput]
  $lang: String
  ){
  createIRDCustomisation(
    input: {
      name: $name
      code: $code
      status: $status
      hotelId: $hotelId
      restaurantId: $restaurantId
      customAttributes : $customAttributes
      lang:$lang
    }
  ) {
    id
  }
}
`;
export const editIRDCustomisation = `
mutation MyMutation(
  $id:String!
  $name:String!
  $code:String!
  $status:Boolean!
  $hotelId:String!
  $restaurantId:String
  $customAttributes : [CustomAttributeInput]
  $lang: String
  ){
    updateIRDCustomisation(
    input: {
      id: $id
      name: $name
      code: $code
      status: $status
      hotelId: $hotelId
      restaurantId: $restaurantId
      customAttributes : $customAttributes
      lang:$lang
    }
  ) {
    id
  }
}
`;
export const deactivateIRDCustomisation = `
mutation MyMutation(
  $id:String!
  $hotelId:String!
  $restaurantId: String
  $lang: String
  ) {
  disableIRDCustomisation(
    input: {
      id: $id
      hotelId: $hotelId
      restaurantId: $restaurantId
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;
export const activateIRDCustomisation = `
mutation MyMutation(
  $id:String!
  $hotelId:String!
  $restaurantId: String
  $lang: String
  ) {
  enableIRDCustomisation(
    input: {
      id:$id
      hotelId: $hotelId
      restaurantId: $restaurantId
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;
export const deleteIRDCustomisation = `
mutation MyMutation(
  $id:String!
  $hotelId:String!
  $restaurantId: String
  $lang: String
){
  deleteIRDCustomisation(
    input: {
      id:$id
      hotelId: $hotelId
      restaurantId: $restaurantId
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const addIRDDiscount = `
mutation CreateIRDDiscount(
  $hotelId: String!
  $restaurantId: String
  $name: String!
  $code: String!
  $value: Int!
  $upto: Int!
  $disclaimer: String
  $description: String
  $schedule: IRDDiscountScheduleInput!
  $status: Boolean
  $customAttributes : [CustomAttributeInput]
  $lang: String
) {
  createIRDDiscount(
    input: {
      hotelId: $hotelId
      restaurantId: $restaurantId
      code: $code
      name: $name
      value: $value
      upto: $upto
      disclaimer: $disclaimer
      description: $description
      schedule: $schedule
      status: $status
      customAttributes : $customAttributes
      lang:$lang
    }
  ) {
    id
  }
}
`;

export const editIRDDiscount = `
mutation UpdateIRDDiscount(
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $name: String!
  $code: String!
  $value: Int!
  $upto: Int!
  $disclaimer: String
  $description: String
  $schedule: IRDDiscountScheduleInput!
  $status: Boolean
  $customAttributes : [CustomAttributeInput]
  $lang: String
) {
  updateIRDDiscount(
    input: {
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id
      code: $code
      name: $name
      value: $value
      upto: $upto
      disclaimer: $disclaimer
      description: $description
      schedule: $schedule
      status: $status
      customAttributes : $customAttributes
      lang:$lang
    }
  ) {
    id
  }
}
`;

export const deleteIRDDiscount = `
mutation DeleteIRDDiscount (
  $id: String!
  $hotelId: String!
  $restaurantId: String
  $lang: String
) {
  deleteIRDDiscount(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id 
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const enableIRDDiscount = `
mutation MyMutation (
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  enableIRDDiscount(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id 
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const disableIRDDiscount = `
mutation MyMutation (
  $hotelId: String!
  $restaurantId: String
  $id: String!
  $lang: String
) {
  disableIRDDiscount(
    input: { 
      hotelId: $hotelId
      restaurantId: $restaurantId
      id: $id 
      lang:$lang
    }
  ) {
    status
    message
  }
}
`;

export const createIRDCombo = `mutation CreateIRDBundle(
  $hotelId:String!
  $restaurantId:String
  $code:String!
  $name:String!
  $status:Boolean!
  $price:Int!
  $description:String!
  $items:[String]!
  $addons: IRDAddonsInput!
  $upsellStatus:Boolean!
  $upsellItems:[String]
  $images:[ImagesInput]
  $customAttributes : [CustomAttributeInput]
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  createIRDBundle(
    input: {
      hotelId: $hotelId
      restaurantId: $restaurantId
      code: $code
      name: $name
      status: $status
      price: $price
      description: $description
      items: $items
      addons: $addons
      upsell: {
        status: $upsellStatus
        items: $upsellItems
      }
      images: $images
      customAttributes : $customAttributes
      lang:$lang
      mediaContent: $mediaContent
    }
  ) {
    id
  }
}`;

export const updateIRDCombo = `mutation UpdateIRDBundle(
  $hotelId:String!
  $restaurantId:String
  $id:String!
  $code:String!
  $name:String!
  $status:Boolean!
  $price:Int!
  $description:String!
  $items:[String]!
  $addons: IRDAddonsInput!
  $upsellStatus:Boolean!
  $upsellItems:[String]
  $images:[ImagesInput]
  $customAttributes : [CustomAttributeInput]
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  updateIRDBundle(
    input: {
      hotelId: $hotelId
      restaurantId: $restaurantId
      id:$id
      code: $code
      name: $name
      status: $status
      price: $price
      description: $description
      items: $items
      addons: $addons
      upsell: {
        status: $upsellStatus
        items: $upsellItems
      }
      images: $images
      customAttributes : $customAttributes
      lang:$lang
      mediaContent: $mediaContent
    }
  ) {
    id
  }
}`;

export const disableIRDCombo = `
mutation DisableIRDBundle(
  $id:String!
  $hotelId:String!
  $restaurantId: String
  $lang: String
) {
  disableIRDBundle(
  input: {
    hotelId: $hotelId
    restaurantId:$restaurantId
    id: $id
    lang:$lang
  }) {
    status
    message
  }
}`;

export const enableIRDCombo = `
mutation EnableIRDBundle(
  $id:String!
  $hotelId:String!
  $restaurantId: String
  $lang: String
) {
  enableIRDBundle(
    input:{
      id: $id
      hotelId: $hotelId
      restaurantId:$restaurantId
    lang:$lang
    }) {
    status
    message
  }
}`;

export const deleteIRDCombo = `
mutation DeleteIRDBundle(
  $id:String!
  $hotelId:String!
  $restaurantId: String
  $lang: String
  ) {
  deleteIRDBundle(
    input:{
      id: $id
      hotelId: $hotelId
      restaurantId:$restaurantId
    lang:$lang
    }) {
    status
    message
  }
}`;

export const addIRDMenu = `
mutation MyMutation(
  $code:String!
  $name:String!
  $description:String
  $isActive:Boolean!
  $hours: [IRDHoursInput]
  $categories:[IRDMenuCategoryInput]
  $hotelId:String!
  $restaurantId:String
  $menuURL:String
  $menuType:String
  $images:[ImagesInput]
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  createIRDMenu(
    input:{
      code:$code
      name:$name
      description:$description
      isActive:$isActive
      hours:$hours
      categories:$categories
      hotelId:$hotelId
      restaurantId:$restaurantId
      menuURL:$menuURL
      menuType:$menuType
      images:$images
    lang:$lang
      mediaContent:$mediaContent
    }) 
      {
        id
      }
}`;

export const updateIRDMenu = `
mutation MyMutation(
  $code:String
  $name:String!
  $description:String
  $isActive:Boolean!
  $hours: [IRDHoursInput]
  $categories:[IRDMenuCategoryInput]
  $hotelId:String!
  $restaurantId:String
  $images:[ImagesInput]
  $id:String!
  $menuURL:String
  $menuType:String
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  updateIRDMenu(
    input:{
      code:$code
      name:$name
      description:$description
      isActive:$isActive
      hours:$hours
      categories:$categories
      hotelId:$hotelId
      restaurantId:$restaurantId
      images:$images
      id:$id
      menuURL:$menuURL
      menuType:$menuType
      mediaContent:$mediaContent
    lang:$lang
    }) 
      {
        id
      }
}`;

export const disableIRDMenu = `
mutation MyMutation(
  $hotelId:String!
  $restaurantId:String
  $id:String!
  $lang: String
) {
  disableIRDMenu(
    input:{
      hotelId:$hotelId
      restaurantId:$restaurantId
      id:$id
    lang:$lang
    }) {
    message
    status
  }
}`;

export const enableIRDMenu = `
mutation MyMutation(
  $hotelId:String!
  $restaurantId:String
  $id:String!
  $lang: String
) {
  enableIRDMenu(
    input:{
      hotelId:$hotelId
      restaurantId:$restaurantId
      id:$id
    lang:$lang
    }) {
    message
    status
  }
}`;

export const deleteIRDMenu = `
mutation MyMutation(
  $hotelId:String!
  $restaurantId:String
  $id:String!
  $lang: String
) {
  deleteIRDMenu(
    input:{
      hotelId:$hotelId
      restaurantId:$restaurantId
      id:$id
    lang:$lang
    }) {
    message
    status
  }
}`;

export const deactivateOffer = `
mutation MyMutation(
  $hotelId:String!
  $id:String!
  $lang: String

) {
  deactivateOffer(
    input:{
    hotelId:$hotelId
    id:$id
    lang: $lang
  }) {
    message
    status
  }
}`;

export const deactivateOfferCard = `
mutation MyMutation(
  $hotelId:String!
  $id:String!
  $lang: String
) {
  deactivateOfferCard(
    input:{
    hotelId:$hotelId
    id:$id
    lang: $lang
  }) {
    message
    status
  }
}`;

export const activateOffer = `
mutation MyMutation(
  $hotelId:String!
  $id:String!
  $lang: String

) {
  activateOffer(
    input:{
    hotelId:$hotelId
    id:$id
    lang: $lang
  }) {
    message
    status
  }
}`;

export const activateOfferCard = `
mutation MyMutation(
  $hotelId:String!
  $id:String!
  $lang: String
) {
  activateOfferCard(
    input:{
    hotelId:$hotelId
    id:$id
    lang: $lang
  }) {
    message
    status
  }
}`;

export const createOffer = `
mutation MyMutation(
  $CTA: OffersCTAInput!
  $description: String!
  $duration: OffersDurationInput!
  $highLights: String
  $hotelId: String!
  $images: [ImagesInput]
  $name: String!
  $type: String!
  $customAttributes : [CustomAttributeInput]
  $contact : OffersContactInput!
  $lang: String
  $selectRestaurant: [SelectRestaurantsInput]
  $mediaContent: [CustomAttributeInput]
) {
  createOffer(
    input: {
      CTA: $CTA
      description: $description
      duration: $duration
      highLights: $highLights
      hotelId: $hotelId
      images: $images
      name: $name
      type: $type
      customAttributes : $customAttributes
      contact : $contact
      lang: $lang
      selectRestaurant: $selectRestaurant
      mediaContent: $mediaContent
  }) {
    id
  }
}`;

export const createOfferCard = `
mutation MyMutation(
  $CTA: OffersCTAInput!
  $schedule: OfferCardScheduleInput!
  $hotelId: String!
  $postScratchImages: [ImagesInput]
  $popUpImages: [ImagesInput]
  $preScratchImages: [ImagesInput]
  $offerCardName: String!
  $offerCardType: EnumOfferCardType
  $customAttributes : [CustomAttributeInput]
  $lang: String
  $offerId: String
  $offerRecipient: String
  $offerName: String
  $mediaContent: [CustomAttributeInput]
) {
  createOfferCard(
    input: {
      CTA: $CTA
      schedule: $schedule
      hotelId: $hotelId
      postScratchImages: $postScratchImages
      preScratchImages: $preScratchImages
      offerCardName: $offerCardName
      customAttributes : $customAttributes
      lang: $lang
      offerCardType: $offerCardType
      offerId: $offerId
      offerRecipient: $offerRecipient
      offerName: $offerName
      popUpImages: $popUpImages
      mediaContent: $mediaContent
  }) {
    id
  }
}`;

export const updateOfferCard = `
mutation MyMutation(
  $CTA: OffersCTAInput!
  $schedule: OfferCardScheduleInput!
  $hotelId: String!
  $postScratchImages: [ImagesInput]
  $preScratchImages: [ImagesInput]
  $popUpImages: [ImagesInput]
  $offerCardName: String!
  $offerCardType: EnumOfferCardType
  $customAttributes : [CustomAttributeInput]
  $lang: String
  $offerId: String
  $offerRecipient: String
  $id: String!
  $offerName: String
  $mediaContent: [CustomAttributeInput]
) {
  updateOfferCard(
    input: {
      id: $id
      CTA: $CTA
      schedule: $schedule
      hotelId: $hotelId
      postScratchImages: $postScratchImages
      preScratchImages: $preScratchImages
      offerCardName: $offerCardName
      customAttributes : $customAttributes
      lang: $lang
      offerCardType: $offerCardType
      offerId: $offerId
      offerRecipient: $offerRecipient
      offerName: $offerName
      popUpImages: $popUpImages
      mediaContent: $mediaContent
  }) {
    id
  }
}`;

export const updateOffer = `
mutation MyMutation(
  $CTA: OffersCTAInput!
  $description: String!
  $duration: OffersDurationInput!
  $highLights: String!
  $hotelId: String!
  $id: String!
  $images: [ImagesInput]!
  $name: String!
  $type: String!
  $customAttributes : [CustomAttributeInput]
  $contact : OffersContactInput!
  $lang: String
  $selectRestaurant: [SelectRestaurantsInput]
  $mediaContent: [CustomAttributeInput]
) {
  updateOffer(
    input: {
      CTA: $CTA
      description: $description
      duration: $duration
      highLights: $highLights
      hotelId: $hotelId
      id: $id
      images: $images
      name: $name
      type: $type
      customAttributes : $customAttributes
      contact : $contact
      lang: $lang
      selectRestaurant: $selectRestaurant
      mediaContent: $mediaContent
  }) {
    id
  }
}`;

export const deleteOffer = `
mutation MyMutation(
  $hotelId:String!
  $id:String!
  $lang: String
) {
  deleteOffer(
    input:{
    hotelId:$hotelId
    id:$id
    lang: $lang
  }) {
    message
    status
  }
}`;

export const deleteOfferCard = `
mutation MyMutation(
  $hotelId:String!
  $id:String!
  $lang: String
) {
  deleteOfferCard(
    input:{
    hotelId:$hotelId
    id:$id
    lang: $lang
  }) {
    message
    status
  }
}`;

export const pushNotification = `
mutation MyMutation(
  $hotelId:String!
  $id:String!
  $notification:OffersNotificationInput!
  $lang: String
) {
  pushNotification(
    input:{
      hotelId: $hotelId
      id: $id
      notification: $notification
      lang: $lang
    }) {
      message
      status
  }
}`;

export const createExtension = `
mutation MyMutation(
  $hotelId:String!
  $roomNumber:String!
  $extensionNumber:String!
  $password: String!
  $lang: String
) {
  createExtension(input: {
      hotelId: $hotelId
      roomNumber: $roomNumber
      extensionNumber: $extensionNumber
      password: $password
      lang: $lang
  }) {
    id
  }
}
`;

export const updateExtension = `
mutation MyMutation(
  $hotelId:String!
  $id: String!
  $roomNumber:String!
  $extensionNumber:String!
  $password: String!
  $lang: String
) {
  updateExtension(input: {
      hotelId: $hotelId
      id: $id
      roomNumber: $roomNumber
      extensionNumber: $extensionNumber
      password: $password
      lang: $lang
  }) {
    id
  }
}
`;

export const deleteExtension = `
mutation MyMutation(
  $hotelId: String!
  $id: String!
  $lang: String
) {
  deleteExtension(
    input: { 
      hotelId: $hotelId
      id: $id
      lang: $lang
     }
    ) {
    status
  }
}
`;

export const createDirectory = `
mutation MyMutation(
  $hotelId: String!
  $name: String!
  $code: String!
  $extensionNumber: String!
  $extensionPassword: String!
  $icon: String!
  $description: String!
  $isActive: Boolean!
  $lang: String
) {
  createDirectory(
    input: {
      code: $code
      description: $description 
      extensionNumber: $extensionNumber 
      extensionPassword: $extensionPassword 
      hotelId: $hotelId 
      isActive: $isActive 
      icon: $icon 
      name: $name
      lang: $lang
    }
    ) {
    id
  }
}`;

export const updateDirectory = `
mutation MyMutation(
  $hotelId: String!
  $name: String!
  $code: String!
  $extensionNumber: String!
  $extensionPassword: String!
  $icon: String!
  $description: String!
  $isActive: Boolean!
  $id: String!
  $lang: String
) {
  updateDirectory(
    input: {
      hotelId: $hotelId
      name: $name
      code: $code
      extensionNumber: $extensionNumber
      extensionPassword: $extensionPassword
      icon: $icon
      description: $description
      isActive: $isActive
      id: $id
      lang: $lang
      }) {
    id
  }
}`;

export const deactivateDirectory = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $lang: String
) {
  deactivateDirectory(
    input: {
      hotelId: $hotelId 
      id: $id
      lang: $lang
    }) {
    id
  }
}`;

export const activateDirectory = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $lang: String
) {
  activateDirectory(
    input: {
      hotelId: $hotelId 
      id: $id
      lang: $lang
    }) {
    id
  }
}`;

export const deleteDirectory = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $lang: String
) {
  deleteDirectory(
    input: {
      id: $id 
      hotelId: $hotelId
      lang: $lang
    }) {
    status
  }
}`;

export const uploadExtension = `
mutation MyMutation(
  $IsReplace: Boolean!
  $hotelId: String!
  $extensions: [ExtensionInput]!
  $lang: String
) {
  addExtensions (
    input: {
      IsReplace: $IsReplace
      hotelId: $hotelId
      extensions: $extensions
      lang: $lang
    }) {
    status
    hotelId
    duplicates {
      extensionNumber
      roomNumber
      password
    }
  }
}`;

export const deleteUser = `
mutation MyMutation(
  $id: String!
) {
  deleteUser(id: $id) {
    id
  }
}`;

export const removeUserActiveLock = `
mutation MyMutation(
  $id: String!
) {
  removeUserActiveLock(id: $id) {
    id
  }
}`;

export const createCampaignNotifications = `
mutation MyMutation(
  $hotelId: String!
	$type: String!
	$title: String!
	$message: String!
	$devices: [String]!
	$recipient: String
	$images: [ImagesInput]
	$offerSchedule: OfferScheduleInput!
  $timezone:String!
  $timeOffset:String
  $residentFloor:[String]
  $residentRoomType:[String]
  $residentRoom:[String]
  $residentFloorIds: [String]
  $residentRoomTypeIds: [String]
  $lang:String!
  $mediaContent: [CustomAttributeInput]
) {
  createCampaignOffer(
    input: {
      hotelId: $hotelId
      type: $type
      title: $title
      message: $message
      devices: $devices
      recipient: $recipient
      images: $images
      offerSchedule: $offerSchedule
      timezone: $timezone
      timeOffset: $timeOffset
      residentFloor: $residentFloor
      residentRoomType: $residentRoomType
      residentRoom: $residentRoom
      residentFloorIds:$residentFloorIds
      residentRoomTypeIds:$residentRoomTypeIds
      lang: $lang
      mediaContent: $mediaContent
    }
    ) {
    id
  }
}
`;

export const updateCampaignNotifications = `
mutation MyMutation(
  $id:String!
  $hotelId: String!
	$type: String!
	$title: String!
	$message: String!
	$devices: [String]!
	$recipient: String
	$images: [ImagesInput]
	$offerSchedule: OfferScheduleInput!
  $timezone:String!
  $timeOffset:String
  $residentFloor:[String]
  $residentRoomType:[String]
  $residentRoom:[String]
  $residentFloorIds: [String]
  $residentRoomTypeIds: [String]
  $lang:String!
  $mediaContent: [CustomAttributeInput]
) {
  updateCampaignOffer(
    input: {
      id: $id
      hotelId: $hotelId
      type: $type
      title: $title
      message: $message
      devices: $devices
      recipient: $recipient
      images: $images
      offerSchedule: $offerSchedule
      timezone: $timezone
      timeOffset: $timeOffset
      residentFloor: $residentFloor
      residentRoomType: $residentRoomType
      residentRoom: $residentRoom
      residentFloorIds:$residentFloorIds
      residentRoomTypeIds:$residentRoomTypeIds
      lang: $lang
      mediaContent: $mediaContent
    }
    ) {
    id
  }
}
`;

export const deleteCampaignOffer = `
mutation MyMutation(
  $id:String!
  $hotelId: String!
  $lang:String!
) {
  deleteCampaignOffer(
    input: {
      id: $id
      hotelId: $hotelId
      lang: $lang
    }
    ){
      message
      status
    }
}
`;

export const deactivateCampaignOffer = `
mutation MyMutation(
  $id:String!
  $hotelId: String!
  $lang:String!
  $state:Boolean!
) {
  deactivateCampaignOffer(
    input: {
      id: $id
      hotelId: $hotelId
      lang: $lang
      state: $state
    }
    ){
      message
      status
    }
}
`;

export const createLocation =
  /* GraphQL */
  `
    mutation MyMutation(
      $description: String!
      $type: LocationType!
      $hotelId: String!
      $name: String!
      $lang: String!
    ) {
      createLocation(
        input: {
          description: $description
          hotelId: $hotelId
          name: $name
          type: $type
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const updateLocation =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $type: LocationType!
      $description: String!
      $hotelId: String!
      $name: String!
      $lang: String!
    ) {
      updateLocation(
        input: {
          id: $id
          type: $type
          description: $description
          hotelId: $hotelId
          name: $name
          lang: $lang
        }
      ) {
        id
      }
    }
  `;

export const deleteLocation = `
  mutation MyMutation(
    $hotelId: String!
    $id: String!
  $lang:String!
  ) {
    deleteLocation(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang
      }
    ) {
    status
    }
  }
  `;

export const createTVCategory = `
    mutation MyMutation(
      $code: String
      $isActive: Boolean!
      $hotelId: String!
      $name: String!
      $lang: String
    ) {
      createTVCategory(
        input: {
          code: $code
          hotelId: $hotelId
          name: $name
          isActive: $isActive
          lang:$lang
        }
      ) {
        id
      }
    }
  `;

export const updateTVCategory = `
    mutation MyMutation(
      $id: String!
      $code: String
      $isActive: Boolean!
      $hotelId: String!
      $name: String!
      $lang: String
    ) {
      updateTVCategory(
        input: {
          id: $id
          code: $code
          hotelId: $hotelId
          name: $name
          isActive: $isActive
          lang:$lang
        }
      ) {
        id
      }
    }
  `;

export const deleteTVCategory = `
  mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deleteTVCategory(
      input: {
        hotelId: $hotelId
        id: $id
        lang:$lang
      }
    ) {
    status
    }
  }
  `;

export const reassignTVCategory = `  
  mutation MyMutation(
    $hotelId: String!
    $newCategoryID: String!
    $oldCategoryID:String!,
    $oldCategoryName:String!,
    $newCategoryName:String!
    $lang: String
  ) {
    reassignTVCategory(input: {hotelID:$hotelId, newCategoryID: $newCategoryID, oldCategoryID: $oldCategoryID,
      oldCategoryName: $oldCategoryName, newCategoryName: $newCategoryName, lang:$lang
    }) {
      message
      status
    }
  }
  `;

export const createBouquet =
  /* GraphQL */
  `
    mutation MyMutation(
      $code: String!
      $hotelId: String!
      $name: String!
      $floor: [String]
      $room: [String]
      $location: [String]
      $lang: String
      $floorIDs: [String]!
      $locationIds: [String]!
    ) {
      createBouquet(
        input: {
          floor: $floor
          location: $location
          room: $room
          code: $code
          hotelId: $hotelId
          name: $name
          lang: $lang
          floorIDs: $floorIDs
          locationIds: $locationIds
        }
      ) {
        id
        code
        createdAt
        createdBy
        hotelId
        floor
        location
        name
        pk
        room
        sk
        updatedAt
        updatedBy
        version
      }
    }
  `;

export const updateBouquet =
  /* GraphQL */
  `
    mutation MyMutation(
      $id: String!
      $code: String!
      $hotelId: String!
      $name: String!
      $floor: [String]!
      $room: [String]!
      $location: [String]!
      $lang: String
      $floorIDs: [String]!
      $locationIds: [String]!
    ) {
      updateBouquet(
        input: {
          id: $id
          floor: $floor
          location: $location
          room: $room
          code: $code
          hotelId: $hotelId
          name: $name
          lang: $lang
          floorIDs: $floorIDs
          locationIds: $locationIds
        }
      ) {
        id
        code
        createdAt
        createdBy
        hotelId
        floor
        location
        name
        pk
        room
        sk
        updatedAt
        updatedBy
        version
      }
    }
  `;

export const deleteBouquet = `
mutation MyMutation(
  $hotelId: String!
  $id: String!
  $lang:String
) {
  deleteBouquet(input: {hotelId: $hotelId, id: $id, lang:$lang}) {
    message
    status
  }
}
`;

export const createCityGuide = `
    mutation MyMutation(
      $categoryId: String!
      $hotelId: String!
      $name: String!
      $code: String
      $description: String!
      $distanceFromHotel: Float!
      $units: String!
      $isActive: Boolean!
      $location: CityGuideLocationInput
      $information: [CityGuideInformationInput]
      $duration: CityGuideDurationInput
      $images: [ImagesInput]
      $lang: String
      $mediaContent: [CustomAttributeInput]

    ) {
      createCityGuide(
        input: {
          categoryId: $categoryId,
          hotelId:$hotelId
          name:$name
          code:$code
          description:$description
          distanceFromHotel:$distanceFromHotel
          units:$units
          isActive:$isActive
          location:$location
          information:$information
          duration:$duration
          images:$images
          lang: $lang
          mediaContent: $mediaContent
        }
      ) {
        id
      }
    }
`;

export const updateCityGuide = `
mutation MyMutation(
  $categoryId: String!
  $id: String!
  $hotelId: String!
  $name: String!
  $code: String
  $description: String!
  $distanceFromHotel: Float!
  $units: String!
  $isActive: Boolean!
  $location: CityGuideLocationInput
  $information: [CityGuideInformationInput]
  $duration: CityGuideDurationInput
  $images: [ImagesInput]
  $lang: String
  $mediaContent: [CustomAttributeInput]
) {
  updateCityGuide(
    input: {
      categoryId: $categoryId,
      id:$id
      hotelId:$hotelId
      name:$name
      code:$code
      description:$description
      distanceFromHotel:$distanceFromHotel
      units:$units
      isActive:$isActive
      location:$location
      information:$information
      duration:$duration
      images:$images
      lang: $lang
      mediaContent: $mediaContent
    }
  ) {
    id
  }
}
`;

export const deleteCityGuide = `
mutation MyMutation(
  $hotelId: String!
  $id: String!
  $lang: String
){
  deleteCityGuide(input: {
    hotelId: $hotelId
    id: $id
    lang: $lang
  }
  ){
    message
    status
  }
}
`;

export const updateCityGuideState = `
mutation MyMutation(
  $hotelId: String!
  $id: String!
  $status: Boolean!
  $lang: String
){
  updateCityGuideState(input: {
    hotelId: $hotelId
    id: $id
    status: $status
    lang: $lang
  }
  ){
    message
    status
  }
}
`;

export const cityGuideCategory = `
    mutation MyMutation($hotelId: String!,$name: String!, $lang: String) {
      createCityGuideCategory(
        input: { hotelId: $hotelId,name: $name, lang: $lang }
      ) {
        id
      }
    }
  `;

export const updateCityGuidesCategory = `
    mutation MyMutation(
      $id: String!
      $hotelId: String!
      $name: String!
      $lang: String
    ) {
      updateCityGuideCategory(
        input: { id: $id, hotelId: $hotelId,name: $name, lang: $lang }
      ) {
        id
      }
    }
  `;

export const deleteCityGuidesCategory = `
  mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deleteCityGuideCategory(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang
      }
    ) {
    status
    }
  }
  `;

export const createFeedback = `
mutation MyMutation(
  $hotelId: String!
  $destination: String!
  $duration: Int!
  $pageTitle: String!
  $subtext: String
  $isActive: Boolean
  $feedbackCategories: [FeedbackCategoryInput]!
  $lang: String
) {
  createFeedback(
    input: {
      hotelId:$hotelId
      destination:$destination
      duration:$duration
      pageTitle:$pageTitle
      subtext:$subtext
      isActive:$isActive
      feedbackCategories:$feedbackCategories
      lang: $lang
    }
  ) {
    id
  }
}
`;

export const updateFeedback = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $destination: String!
  $duration: Int!
  $pageTitle: String!
  $subtext: String
  $isActive: Boolean
  $feedbackCategories: [FeedbackCategoryInput]!
  $lang: String
) {
  updateFeedback(
    input: {
      id:$id
      hotelId:$hotelId
      destination:$destination
      duration:$duration
      pageTitle:$pageTitle
      subtext:$subtext
      isActive:$isActive
      feedbackCategories:$feedbackCategories
      lang: $lang
    }
  ) {
    id  
  }
}
`;
export const activateFeedback = `
mutation MyMutation(
  $hotelId: String!
  $id: String!
  $lang: String
) {
  activateFeedback(input: {
    hotelId: $hotelId
    id: $id
    lang: $lang
  }) {
    id
  }
}
`;

export const deactivateFeedback = `
mutation MyMutation(
  $hotelId: String!
  $id: String!
  $lang: String
) {
  deactivateFeedback(input: {
    hotelId: $hotelId
    id: $id
    lang: $lang
  }) {
    id
  }
}
`;

export const deleteFeedback = `
mutation MyMutation(
  $hotelId: String!
  $id: String!
  $lang: String
) {
  deleteFeedback(input: {
    hotelId: $hotelId
    id: $id
    lang: $lang
  }) {
    status
  }
}
`;
export const createLiveChannel = `
mutation MyMutation (
  $hotelId: String!
    $categoryName: String!
    $name: String!
    $code: String!
    $number: String!
    $categoryId: String!
    $language: String!
    $description: String!
    $externalURL: String!
    $tvType: String!
    $status: Boolean!
    $epgURL: String!
    $isEpgURL: Boolean!
    $isDRM: Boolean!
    $images: [ImagesInput]
    $iptv: IPTVInput
    $coaxial: CoaxialInput
    $bouquet: [ChannelBouquetInput]!
    $lang: String
    $pushChannel: Boolean
) {
  createLiveTv(
    input: {
      bouquet: $bouquet
      categoryId: $categoryId
      language: $language
      number: $number
      coaxial: $coaxial
      code: $code
      description: $description
      epgURL: $epgURL
      hotelId: $hotelId
      externalURL: $externalURL
      images: $images
      iptv: $iptv
      isEpgURL: $isEpgURL
      isDRM: $isDRM
      name: $name
      categoryName: $categoryName
      status: $status
      tvType: $tvType
      lang: $lang
      pushChannel: $pushChannel   
       }
    ) {
      bouquet {
        id
        name
      }
      categoryId
      categoryName
      coaxial {
        broadCastStandard
        bandwidth
        digitalTelevisionFormat
        frequency
        majorNumber
        modulationType
        polarization
        programNumber
        satelliteId
        symbolRate
      }
      code
      createdAt
      createdBy
      description
      epgURL
      hotelId
      id
      externalURL
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
      iptv {
        port
        url
      }
      isDRM
      isEpgURL
      language
      name
      number
      pk
      sk
      status
      tvType
      updatedAt
      updatedBy
      version
  }
}
    `;

export const updateLiveChannel = `
mutation MyMutation (
  $id: String!
  $hotelId: String!
  $categoryName: String!
  $name: String!
  $code: String!
  $number: String!
  $categoryId: String!
  $language: String!
  $description: String!
  $externalURL: String!
  $tvType: String!
  $status: Boolean!
  $epgURL: String!
  $isEpgURL: Boolean!
  $isDRM: Boolean!
  $images: [ImagesInput]
  $iptv: IPTVInput
  $coaxial: CoaxialInput
  $bouquet: [ChannelBouquetInput]!
  $lang: String
  $pushChannel: Boolean
  $swapChannel: Boolean
) {
  updateLiveTv(
    input: {
      id: $id
      bouquet: $bouquet
      categoryId: $categoryId
      language: $language
      number: $number
      coaxial: $coaxial
      code: $code
      description: $description
      epgURL: $epgURL
      hotelId: $hotelId
      externalURL: $externalURL
      images: $images
      iptv: $iptv
      isEpgURL: $isEpgURL
      isDRM: $isDRM
      name: $name
      categoryName: $categoryName
      status: $status
      tvType: $tvType
      lang: $lang
      pushChannel: $pushChannel
      swapChannel: $swapChannel
    }
    ) {
      bouquet {
        id
        name
      }
      categoryId
      categoryName
      coaxial {
        broadCastStandard
        bandwidth
        digitalTelevisionFormat
        frequency
        majorNumber
        modulationType
        polarization
        programNumber
        satelliteId
        symbolRate
      }
      code
      createdAt
      createdBy
      description
      epgURL
      hotelId
      id
      externalURL
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
      iptv {
        port
        url
      }
      isDRM
      isEpgURL
      language
      name
      number
      pk
      sk
      status
      tvType
      updatedAt
      updatedBy
      version
  }
}
    `;

export const deleteLiveChannel = `
  mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
    deleteLiveTv(
      input: {
        hotelId: $hotelId
        id: $id
        lang: $lang
      }
    ) {
      message
      status
    }
  }
  `;

export const changeTVStatus = `
  mutation MyMutation(
    $hotelId: String!
    $id: String!
    $status: Boolean!
    $lang: String
  ) {
    changeTVStatus(
      input: {
        hotelID: $hotelId
        livetvID: $id
        status: $status
        lang:$lang
      }
    ) {
      message
      status
    }
  }
  `;
export const changeSpaStatus = `
  mutation MyMutation(
    $hotelID: String!
    $spaID: String!
    $isActive: Boolean!
    $lang: String
  ) {
    changeSpaStatus(
      input: {
        hotelID: $hotelID
        spaID: $spaID
        isActive: $isActive
        lang: $lang
      }
    ) {
      message
      status
    }
  }
  `;

export const changeSpaTreatmentStatus = `
  mutation MyMutation(
    $hotelID: String!
    $treatmentID: String!
    $isActive: Boolean!
    $lang: String
  ){
    changeSpaTreatmentStatus(
      input: {
        hotelID: $hotelID
        treatmentID: $treatmentID
        isActive: $isActive 
        lang: $lang
      }
    ) {
      message
      status
    }
  }
  `;

export const changeRestaurantInfoStatus = `
mutation MyMutation(
  $hotelID: String!
  $id: String!
  $isActive: Boolean!
){
  changeRestaurantStatus(
    input: {
      hotelID: $hotelID
      id: $id
      isActive: $isActive 
    }
  ) {
    message
    status
  }
}
`;

export const deactivateRateFilter = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    deactivateAccommodationRateFilter(input: {hotelId: $hotelId, id: $id, lang:$lang}) {
      message
      status
    }
}`;

export const activateRateFilter = `
  mutation MyMutation(
    $hotelId:String!
    $id: String!
    $lang: String
  ) {
    activateAccommodationRateFilter(input: {hotelId: $hotelId, id: $id, lang:$lang}) {
      message
      status
    }
}`;

export const uploadTvChannelsByCSV = `
mutation MyMutation(
  $IsReplace: Boolean!
  $hotelId: String!
  $tvChannels: [LiveTvInputBulkUpload]!
  $lang: String
) {
  uploadTvChannelsByCSV (
    input: {
      IsReplace: $IsReplace
      hotelId: $hotelId
      tvChannels: $tvChannels
      lang: $lang
    }) {
    status
    hotelId
  }
}`;

export const uploadBouquetsByCSV = `
mutation MyMutation(
  $IsReplace: Boolean!
  $hotelId: String!
  $bouquets: [CreateBouquetInput]!
  $lang: String
) {
  uploadBouquetsByCSV (
    input: {
      IsReplace: $IsReplace
      hotelId: $hotelId
      bouquets: $bouquets
      lang: $lang
    }) {
    status
    hotelId
  }
}`;

export const uploadCategoriesByCSV = `
mutation MyMutation(
  $IsReplace: Boolean!
  $hotelId: String!
  $categories: [CreateTVCategoryInput]!
  $lang: String
) {
  uploadCategoriesByCSV (
    input: {
      IsReplace: $IsReplace
      hotelId: $hotelId
      categories: $categories
      lang: $lang
    }) {
    status
    hotelId
  }
}`;

export const syncSRS = `
mutation MyQuery($hotelId:String!) {
  syncSRS(input: {hotelId: $hotelId}) {
    message
    status
  }
}
`;

export const updateSpaSyncConfig = `
mutation MyQuery($hotelId:String!, $allowedRoles: [String]!, $isEnabled: Boolean!) {
  updateSpaSyncConfig(input: {hotelId: $hotelId, allowedRoles: $allowedRoles, isEnabled: $isEnabled}) {
    message
    status
  }
}
`;

export const syncPOS = `
mutation MyQuery($hotelId:String!) {
  syncPOS(input: {hotelId: $hotelId}) {
    message
    status
  }
}
`;

export const updateIRDSyncConfig = `
mutation MyQuery($hotelId:String!, $allowedRoles: [String]!, $isEnabled: Boolean!) {
  updateIRDSyncConfig(input: {hotelId: $hotelId, allowedRoles: $allowedRoles, isEnabled: $isEnabled}) {
    message
    status
  }
}
`;

export const updateHKSyncConfig = `
mutation MyQuery($hotelId:String!, $allowedRoles: [String]!, $isEnabled: Boolean!) {
  updateHKSyncConfig(input: {hotelId: $hotelId, allowedRoles: $allowedRoles, isEnabled: $isEnabled}) {
    message
    status
  }
}
`;

export const syncHK = `
mutation MyQuery($hotelId:String!) {
  syncHK(input: {hotelId: $hotelId}) {
    message
    status
  }
}
`;

export const bulkUpdateStatus = `
mutation MyMutation (
  $hotelId: String!
  $all: Boolean
  $ids: [String]
  $lang: String
  $module: String!
  $restaurantId: String
  $status: Boolean
) {
  bulkUpdateStatus(
    input: {
      hotelId:$hotelId,
      all: $all,
      ids: $ids,
      lang: $lang,
      module: $module,
      restaurantId: $restaurantId,
      status: $status,
  }) {
    message
    status
  }
}`;

export const bulkDelete = `
mutation MyMutation (
  $hotelId: String!
  $all: Boolean
  $ids: [String]
  $lang: String
  $module: String!
  $restaurantId: String
) {
  bulkDelete(
    input: {
      hotelId:$hotelId,
      all: $all,
      ids: $ids,
      lang: $lang,
      module: $module,
      restaurantId: $restaurantId,
  }) {
    message
    status
  }
}`;
export const createWelcomeMessage =
  /* GraphQL */
  `
    mutation CreateWelcomeMessage(
      $hotelId: String!
      $title: String!
      $welcomeMessageTemplate: String!
      $deviceTypes: [DeviceType!]!
      $isActive: Boolean!
      $confirmationIds: String!
      $audienceType: AudienceType!
      $audienceCriteria: AudienceCriteriaInput
      $lang: String
    ) {
      createWelcomeMessage(
        input: {
          hotelId: $hotelId
          title: $title
          welcomeMessageTemplate: $welcomeMessageTemplate
          deviceTypes: $deviceTypes
          isActive: $isActive
          confirmationIds: $confirmationIds
          audienceType: $audienceType
          audienceCriteria: $audienceCriteria
          lang: $lang
        }
      ) {
        hotelId
        id
        isActive
        title
        deviceTypes
        welcomeMessageTemplate
        audienceType
        confirmationIds
        audienceCriteria {
          blockCodes {
            logic
            values
          }
          floors {
            logic
            values
          }
          loyaltyTiers {
            logic
            values
          }
          roomTypes {
            logic
            values
          }
          rooms {
            values
            logic
          }
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  `;

export const updateWelcomeMessage =
  /* GraphQL */
  `
    mutation UpdateWelcomeMessage(
      $id: String!
      $hotelId: String!
      $title: String!
      $welcomeMessageTemplate: String!
      $deviceTypes: [DeviceType!]!
      $isActive: Boolean!
      $confirmationIds: String!
      $audienceType: AudienceType!
      $audienceCriteria: AudienceCriteriaInput
      $lang: String
    ) {
      updateWelcomeMessage(
        input: {
          id: $id
          hotelId: $hotelId
          title: $title
          welcomeMessageTemplate: $welcomeMessageTemplate
          deviceTypes: $deviceTypes
          confirmationIds: $confirmationIds
          isActive: $isActive
          audienceType: $audienceType
          audienceCriteria: $audienceCriteria
          lang: $lang
        }
      ) {
        hotelId
        id
        title
        isActive
        welcomeMessageTemplate
        deviceTypes
        confirmationIds
        audienceType
        audienceCriteria {
          blockCodes {
            logic
            values
          }
          floors {
            logic
            values
          }
          loyaltyTiers {
            logic
            values
          }
          roomTypes {
            logic
            values
          }
          rooms {
            logic
            values
          }
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  `;

export const deleteWelcomeMessage =
  /* GraphQL */
  `
    mutation DeleteWelcomeMessage($hotelId: String!, $id: String!, $lang: String) {
      deleteWelcomeMessage(input: { hotelId: $hotelId, id: $id, lang: $lang }) {
        message
        status
      }
    }
  `;

export const updateWelcomeMessageStatus = `mutation UpdateWelcomeMessageStatus(
  $hotelId: String!
  $id: String!
) {
  updateWelcomeMessageStatus(input: {
    hotelId: $hotelId
    id: $id
  }) {
    message
    status
  }
}`;

export const duplicateWelcomeMessage =
  /* GraphQL */
  `
    mutation DuplicateWelcomeMessage($id: String!, $title: String!, $hotelId: String!) {
      duplicateWelcomeMessage(input: { id: $id, title: $title, hotelId: $hotelId }) {
        id
        isActive
        title
        deviceTypes
        welcomeMessageTemplate
        audienceType
        audienceCriteria {
          blockCodes {
            logic
            values
          }
          floors {
            logic
            values
          }
          loyaltyTiers {
            logic
            values
          }
          roomTypes {
            logic
            values
          }
          rooms {
            values
            logic
          }
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  `;

export const duplicateNotification = `
  mutation DuplicateNotification(
    $id: String!
    $hotelId: String!
    $name: String!
    $lang: String
  ) {
    duplicateNotification(
      input: { id: $id, hotelId: $hotelId, name: $name, lang: $lang }
    ) {
      brandId
      createdAt
      createdBy
      groupId
      devices
      hotelId
      id
      isActive
      message
      pk
      recipient
      residentFloor
      residentFloorIds
      residentRoom
      residentRoomType
      residentRoomTypeIds
      sk
      status
      title
      type
      updatedAt
      updatedBy
      version
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to16
        ratio9to21
      }
      offerSchedule {
        impressionsDay
        oneTimeSchedule { date time }
        repeatSchedule { days everyday from time to }
        schedule
      }
    }
  }
`;

export const createPreference = /* GraphQL */ `
  mutation CreatePreference(
    $hotelId: String!
    $code: String!
    $name: String!
    $isActive: Boolean!
    $lang: String!
    $allowMultipleSelection: Boolean
    $description: String!
    $customAttributes: [CustomAttributeInput]
    $preferenceItems: [PreferenceItemInput!]!
  ) {
    createPreference(
      input: {
        hotelId: $hotelId
        code: $code
        name: $name
        isActive: $isActive
        lang: $lang
        allowMultipleSelection: $allowMultipleSelection
        description: $description
        customAttributes: $customAttributes
        preferenceItems: $preferenceItems
      }
    ) {
      code
      createdAt
      createdBy
      customAttributes {
        key
        value
      }
      description
      hotelId
      id
      isActive
      allowMultipleSelection
      name
      preferenceItems {
        code
        description
        isActive
        name
      }
      updatedAt
      updatedBy
      version
    }
  }
`;

export const updatePreference = /* GraphQL */ `
  mutation UpdatePreference(
    $hotelId: String!
    $id: String!
    $code: String!
    $name: String!
    $isActive: Boolean!
    $lang: String!
    $allowMultipleSelection: Boolean
    $description: String!
    $customAttributes: [CustomAttributeInput]
    $preferenceItems: [PreferenceItemInput!]!
  ) {
    updatePreference(
      input: {
        hotelId: $hotelId
        id: $id
        code: $code
        name: $name
        isActive: $isActive
        lang: $lang
        allowMultipleSelection: $allowMultipleSelection
        description: $description
        customAttributes: $customAttributes
        preferenceItems: $preferenceItems
      }
    ) {
      code
      createdAt
      createdBy
      customAttributes {
        key
        value
      }
      description
      hotelId
      id
      isActive
      allowMultipleSelection
      name
      preferenceItems {
        code
        description
        isActive
        name
      }
      updatedAt
      updatedBy
      version
    }
  }
`;

export const deletePreference = /* GraphQL */ `
  mutation DeletePreference($hotelId: String!, $id: String!) {
    deletePreference(input: { hotelId: $hotelId, id: $id }) {
      message
      status
    }
  }
`;

export const updatePreferenceStatus = /* GraphQL */ `
  mutation UpdatePreferenceStatus($hotelId: String!, $id: String!, $lang: String) {
    updatePreferenceStatus(input: { hotelId: $hotelId, id: $id, lang: $lang }) {
      message
      status
    }
  }
`;

export const syncPreference = `
mutation MyQuery($hotelId:String!) {
  syncPreference(input: {hotelId: $hotelId}) {
    message
    status
  }
}
`;

export const enableMFAConfig = `
    mutation enableMFAConfig($userIds: [String!]!, $MfaEnforced: Boolean!) {
      enableMFA(input: {userIds: $userIds, mfaEnforced: $MfaEnforced}) {
        failedCount
        failedUsers
        message
        successCount
      }
    }
`;
